/* eslint-disable */
// @ts-nocheck -- generated AJV standalone code; never edit directly.
// Source: v4/document-template-family.cogo.schema.json
import ajvUcs2LengthModule from "ajv/dist/runtime/ucs2length.js";
import ajvEqualModule from "ajv/dist/runtime/equal.js";
const ajvUcs2Length = typeof ajvUcs2LengthModule === "function" ? ajvUcs2LengthModule : ajvUcs2LengthModule.default;
const ajvEqual = typeof ajvEqualModule === "function" ? ajvEqualModule : ajvEqualModule.default;
"use strict";
export const validate = validate20;
export default validate20;
const schema31 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://cogo.xyz/schemas/v4/document-template-family.cogo.schema.json","title":"Cogo Document Template Family","description":"Structural layer of the canonical v2 family contract shared by flow-page, fixed-page, workbook, and block-page document templates. Native editors and provider adapters remain non-canonical projections. Authoritative admission additionally requires the registered semantic validator.","$comment":"AJV-only validation is not authoritative because JSON Schema cannot resolve cross-record shared slot ids or required-slot binding coverage. Use the combined admission API declared in x-cogo-admission and schema-registry.json.","x-cogo-admission":{"jsonSchemaOnlyAuthoritative":false,"requiredSemanticValidator":"@cogo/schema/document-template-family-runtime#validateDocumentTemplateFamily","combinedAdmissionApi":"@cogo/schema/document-template-family-admission#validateDocumentTemplateFamilyAdmission"},"type":"object","additionalProperties":false,"required":["schemaVersion","familyId","familyVersion","name","description","metadata","legacyTemplateRefs","semanticCore","promotionPolicy","variants"],"properties":{"schemaVersion":{"const":"cogo.document-template-family.v2"},"familyId":{"$ref":"#/$defs/KebabId"},"familyVersion":{"$ref":"#/$defs/Semver"},"name":{"type":"string","minLength":1},"description":{"type":"string","minLength":1},"metadata":{"$ref":"#/$defs/Metadata"},"legacyTemplateRefs":{"type":"array","items":{"$ref":"#/$defs/LegacyTemplateRef"}},"semanticCore":{"$ref":"#/$defs/SemanticCore"},"promotionPolicy":{"$ref":"#/$defs/PromotionPolicy"},"variants":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/Variant"}}},"$defs":{"KebabId":{"type":"string","pattern":"^[a-z0-9]+(?:-[a-z0-9]+)*$"},"Semver":{"type":"string","pattern":"^[0-9]+\\.[0-9]+\\.[0-9]+$"},"Sha256":{"type":"string","pattern":"^sha256:[a-f0-9]{64}$"},"Reference":{"type":"string","minLength":1},"Metadata":{"type":"object","additionalProperties":false,"required":["ownerRef","locale","tags"],"properties":{"ownerRef":{"$ref":"#/$defs/Reference"},"locale":{"type":"string","pattern":"^[a-z]{2,3}(?:-[A-Z]{2})?$"},"tags":{"type":"array","uniqueItems":true,"items":{"$ref":"#/$defs/KebabId"}}}},"LegacyTemplateRef":{"type":"object","additionalProperties":false,"required":["schemaVersion","templateId","templateVersion","manifestRef","manifestSha256"],"properties":{"schemaVersion":{"const":"cogo.document-template.v1"},"templateId":{"$ref":"#/$defs/KebabId"},"templateVersion":{"$ref":"#/$defs/Semver"},"manifestRef":{"$ref":"#/$defs/Reference"},"manifestSha256":{"$ref":"#/$defs/Sha256"}}},"DataSchema":{"type":"object","additionalProperties":false,"required":["ref"],"properties":{"ref":{"$ref":"#/$defs/Reference"},"sha256":{"$ref":"#/$defs/Sha256"}}},"ReferencedSemanticSlot":{"type":"object","additionalProperties":false,"required":["id","slotRef","kind","required","semanticRole"],"properties":{"id":{"$ref":"#/$defs/KebabId"},"slotRef":{"$ref":"#/$defs/Reference"},"kind":{"$ref":"#/$defs/SemanticSlotKind"},"required":{"type":"boolean"},"semanticRole":{"$ref":"#/$defs/KebabId"}}},"InlineSemanticSlot":{"type":"object","additionalProperties":false,"required":["id","kind","bindingPath","required","semanticRole"],"properties":{"id":{"$ref":"#/$defs/KebabId"},"kind":{"$ref":"#/$defs/SemanticSlotKind"},"bindingPath":{"type":"string","pattern":"^/(?:[^/~]|~[01])+(?:/(?:[^/~]|~[01])+)*$"},"required":{"type":"boolean"},"semanticRole":{"$ref":"#/$defs/KebabId"},"shapeRef":{"$ref":"#/$defs/Reference"}}},"SemanticSlot":{"oneOf":[{"$ref":"#/$defs/ReferencedSemanticSlot"},{"$ref":"#/$defs/InlineSemanticSlot"}]},"SemanticSlotKind":{"enum":["scalar","rich-text","table","image","chart","repeated-group","formula-input","provider-property"]},"Tokens":{"type":"object","additionalProperties":false,"required":["designTokenRefs"],"properties":{"designTokenRefs":{"type":"array","minItems":1,"uniqueItems":true,"items":{"$ref":"#/$defs/Reference"}}}},"Asset":{"type":"object","additionalProperties":false,"required":["id","role","sourceRef","mediaType"],"properties":{"id":{"$ref":"#/$defs/KebabId"},"role":{"$ref":"#/$defs/KebabId"},"sourceRef":{"$ref":"#/$defs/Reference"},"mediaType":{"type":"string","minLength":1},"sha256":{"$ref":"#/$defs/Sha256"}}},"GuidelineRef":{"type":"object","additionalProperties":false,"required":["ref","required"],"properties":{"ref":{"$ref":"#/$defs/Reference"},"required":{"type":"boolean"},"sha256":{"$ref":"#/$defs/Sha256"}}},"LlmPolicy":{"type":"object","additionalProperties":false,"required":["allowedRoles","canonicalAuthority","finalWriterAllowed","outputRequiresValidation"],"properties":{"allowedRoles":{"type":"array","minItems":1,"uniqueItems":true,"items":{"enum":["semantic-input-assistant","layout-proposal-assistant","content-revision-assistant"]}},"canonicalAuthority":{"const":false},"finalWriterAllowed":{"const":false},"outputRequiresValidation":{"const":true}}},"ActionFlowRef":{"type":"object","additionalProperties":false,"required":["id","ref","role"],"properties":{"id":{"$ref":"#/$defs/KebabId"},"ref":{"$ref":"#/$defs/Reference"},"role":{"enum":["generation","approval","refresh","export","publication","interaction"]},"sha256":{"$ref":"#/$defs/Sha256"}}},"ProofProfile":{"type":"object","additionalProperties":false,"required":["requiredForPromotion","nativeStructureReadbackRequired","targetReadbackRequired","structureHashRequired","providerVersionPolicy","visualDiffPolicy","evidenceRetention"],"properties":{"requiredForPromotion":{"const":true},"nativeStructureReadbackRequired":{"const":true},"targetReadbackRequired":{"const":true},"structureHashRequired":{"const":true},"providerVersionPolicy":{"const":"required-when-provider"},"visualDiffPolicy":{"enum":["always","when-layout-bearing"]},"evidenceRetention":{"const":"immutable"}}},"SourceProvenance":{"type":"object","additionalProperties":false,"required":["required","sourceRefs","preserveProviderVersion","sourceAdaptersCanonical"],"properties":{"required":{"const":true},"sourceRefs":{"type":"array","minItems":1,"uniqueItems":true,"items":{"$ref":"#/$defs/Reference"}},"preserveProviderVersion":{"const":true},"sourceAdaptersCanonical":{"const":false}}},"SemanticCore":{"type":"object","additionalProperties":false,"required":["dataSchema","slots","tokens","assets","guidelineRefs","llmPolicy","actionFlowRefs","proofProfile","sourceProvenance"],"properties":{"dataSchema":{"$ref":"#/$defs/DataSchema"},"slots":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/SemanticSlot"}},"tokens":{"$ref":"#/$defs/Tokens"},"assets":{"type":"array","items":{"$ref":"#/$defs/Asset"}},"guidelineRefs":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/GuidelineRef"}},"llmPolicy":{"$ref":"#/$defs/LlmPolicy"},"actionFlowRefs":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/ActionFlowRef"}},"proofProfile":{"$ref":"#/$defs/ProofProfile"},"sourceProvenance":{"$ref":"#/$defs/SourceProvenance"}}},"PromotionPolicy":{"type":"object","additionalProperties":false,"required":["humanPromotionRequired","automatedPromotionAllowed","modelMayApprove","evidenceRequired"],"properties":{"humanPromotionRequired":{"const":true},"automatedPromotionAllowed":{"const":false},"modelMayApprove":{"const":false},"evidenceRequired":{"const":true}}},"SourcePolicy":{"type":"object","additionalProperties":false,"required":["canonicalModel","editorAdapters","adapterCanonicalAuthority"],"properties":{"canonicalModel":{"const":"cogo-document-template-family"},"editorAdapters":{"type":"array","minItems":1,"uniqueItems":true,"items":{"enum":["wordgard","cogo-fixed-page-editor","univer","cogo-block-editor","openpencil","google-docs","notion"]}},"adapterCanonicalAuthority":{"const":false}}},"SlotBinding":{"type":"object","additionalProperties":false,"required":["slotId","bindingRef"],"properties":{"slotId":{"$ref":"#/$defs/KebabId"},"bindingRef":{"$ref":"#/$defs/Reference"}}},"ApprovedOmission":{"type":"object","additionalProperties":false,"required":["slotId","reason","approvedByRef","evidenceRef"],"properties":{"slotId":{"$ref":"#/$defs/KebabId"},"reason":{"type":"string","minLength":1},"approvedByRef":{"$ref":"#/$defs/Reference"},"evidenceRef":{"$ref":"#/$defs/Reference"}}},"FlowPageLayout":{"type":"object","additionalProperties":false,"required":["kind","layoutRef","pagination"],"properties":{"kind":{"const":"flow-page"},"layoutRef":{"$ref":"#/$defs/Reference"},"layoutSha256":{"$ref":"#/$defs/Sha256"},"pagination":{"const":"flow"}}},"FixedPageLayout":{"type":"object","additionalProperties":false,"required":["kind","masterRef","canvas"],"properties":{"kind":{"const":"fixed-page"},"masterRef":{"$ref":"#/$defs/Reference"},"canvas":{"enum":["wide","standard","a4","letter"]}}},"WorkbookLayout":{"type":"object","additionalProperties":false,"required":["kind","workbookSidecarRef"],"properties":{"kind":{"const":"workbook"},"workbookSidecarRef":{"$ref":"#/$defs/Reference"}}},"BlockPageLayout":{"type":"object","additionalProperties":false,"required":["kind","blockSchemaRef"],"properties":{"kind":{"const":"block-page"},"blockSchemaRef":{"$ref":"#/$defs/Reference"}}},"TargetOverlayBase":{"type":"object","required":["target","adapter","canonicalAuthority","implementationStatus","readbackRequired"],"properties":{"target":{"enum":["docx","hwpx","pptx","xlsx","pdf","google-docs","notion"]},"adapter":{"$ref":"#/$defs/Reference"},"canonicalAuthority":{"const":false},"implementationStatus":{"enum":["production-ready","partial","planned"]},"readbackRequired":{"const":true}}},"DocxOverlay":{"allOf":[{"$ref":"#/$defs/TargetOverlayBase"},{"type":"object","required":["templateMode"],"properties":{"target":{"const":"docx"},"templateMode":{"enum":["generated-from-cogo","optional-native-template"]}}}],"unevaluatedProperties":false},"HwpxOverlay":{"allOf":[{"$ref":"#/$defs/TargetOverlayBase"},{"type":"object","required":["templateMode"],"properties":{"target":{"const":"hwpx"},"templateMode":{"enum":["generated-from-cogo","optional-native-template"]}}}],"unevaluatedProperties":false},"PptxOverlay":{"allOf":[{"$ref":"#/$defs/TargetOverlayBase"},{"type":"object","required":["capabilityMode","motionOverlayStatus"],"properties":{"target":{"const":"pptx"},"capabilityMode":{"const":"static-only"},"motionOverlayStatus":{"const":"not-implemented"},"sourceTemplateRef":{"$ref":"#/$defs/Reference"}}}],"unevaluatedProperties":false},"XlsxOverlay":{"allOf":[{"$ref":"#/$defs/TargetOverlayBase"},{"type":"object","required":["sourceTemplateRequired","sourceTemplateRef","workbookSidecarRef"],"properties":{"target":{"const":"xlsx"},"sourceTemplateRequired":{"const":true},"sourceTemplateRef":{"$ref":"#/$defs/Reference"},"workbookSidecarRef":{"$ref":"#/$defs/Reference"}}}],"unevaluatedProperties":false},"PdfOverlay":{"allOf":[{"$ref":"#/$defs/TargetOverlayBase"},{"type":"object","required":["outputOnly","editable"],"properties":{"target":{"const":"pdf"},"outputOnly":{"const":true},"editable":{"const":false}}}],"unevaluatedProperties":false},"GoogleDocsOverlay":{"allOf":[{"$ref":"#/$defs/TargetOverlayBase"},{"type":"object","required":["templateMode","sourceTemplateRef","copyBeforeMutation"],"properties":{"target":{"const":"google-docs"},"templateMode":{"const":"native-copy"},"sourceTemplateRef":{"$ref":"#/$defs/Reference"},"copyBeforeMutation":{"const":true}}}],"unevaluatedProperties":false},"NotionCogoBlockTemplateOverlay":{"allOf":[{"$ref":"#/$defs/TargetOverlayBase"},{"type":"object","required":["templateMode","blockTemplateRef","asyncTemplateReadbackRequired"],"properties":{"target":{"const":"notion"},"templateMode":{"const":"cogo-block-template"},"blockTemplateRef":{"$ref":"#/$defs/Reference"},"asyncTemplateReadbackRequired":{"const":false}}}],"unevaluatedProperties":false},"NotionDataSourceTemplateOverlay":{"allOf":[{"$ref":"#/$defs/TargetOverlayBase"},{"type":"object","required":["templateMode","templateSelection","asyncTemplateReadbackRequired"],"properties":{"target":{"const":"notion"},"templateMode":{"const":"data-source-template"},"templateSelection":{"enum":["explicit-template","default-template"]},"templateRef":{"$ref":"#/$defs/Reference"},"asyncTemplateReadbackRequired":{"const":true}},"allOf":[{"if":{"properties":{"templateSelection":{"const":"explicit-template"}},"required":["templateSelection"]},"then":{"required":["templateRef"]},"else":{"not":{"required":["templateRef"]}}}]}],"unevaluatedProperties":false},"TargetOverlay":{"oneOf":[{"$ref":"#/$defs/DocxOverlay"},{"$ref":"#/$defs/HwpxOverlay"},{"$ref":"#/$defs/PptxOverlay"},{"$ref":"#/$defs/XlsxOverlay"},{"$ref":"#/$defs/PdfOverlay"},{"$ref":"#/$defs/GoogleDocsOverlay"},{"$ref":"#/$defs/NotionCogoBlockTemplateOverlay"},{"$ref":"#/$defs/NotionDataSourceTemplateOverlay"}]},"DocxOverlaySelector":{"type":"object","required":["target"],"properties":{"target":{"const":"docx"}}},"HwpxOverlaySelector":{"type":"object","required":["target"],"properties":{"target":{"const":"hwpx"}}},"PptxOverlaySelector":{"type":"object","required":["target"],"properties":{"target":{"const":"pptx"}}},"XlsxOverlaySelector":{"type":"object","required":["target"],"properties":{"target":{"const":"xlsx"}}},"PdfOverlaySelector":{"type":"object","required":["target"],"properties":{"target":{"const":"pdf"}}},"GoogleDocsOverlaySelector":{"type":"object","required":["target"],"properties":{"target":{"const":"google-docs"}}},"NotionOverlaySelector":{"type":"object","required":["target"],"properties":{"target":{"const":"notion"}}},"Variant":{"type":"object","additionalProperties":false,"required":["variantId","name","layoutProfile","capabilityStatus","knownLimitations","layout","sourcePolicy","slotBindings","approvedOmissions","renderTargets","publicationTargets","targetOverlays"],"properties":{"variantId":{"$ref":"#/$defs/KebabId"},"name":{"type":"string","minLength":1},"layoutProfile":{"enum":["flow-page","fixed-page","workbook","block-page"]},"capabilityStatus":{"enum":["production-ready","partial","planned"]},"knownLimitations":{"type":"array","uniqueItems":true,"items":{"type":"string","minLength":1}},"layout":{"oneOf":[{"$ref":"#/$defs/FlowPageLayout"},{"$ref":"#/$defs/FixedPageLayout"},{"$ref":"#/$defs/WorkbookLayout"},{"$ref":"#/$defs/BlockPageLayout"}]},"sourcePolicy":{"$ref":"#/$defs/SourcePolicy"},"slotBindings":{"type":"array","items":{"$ref":"#/$defs/SlotBinding"}},"approvedOmissions":{"type":"array","items":{"$ref":"#/$defs/ApprovedOmission"}},"renderTargets":{"type":"array","uniqueItems":true,"items":{"enum":["docx","hwpx","pptx","xlsx","pdf"]}},"publicationTargets":{"type":"array","uniqueItems":true,"items":{"enum":["google-docs","notion"]}},"targetOverlays":{"type":"array","minItems":1,"uniqueItems":true,"items":{"$ref":"#/$defs/TargetOverlay"}}},"allOf":[{"anyOf":[{"properties":{"renderTargets":{"minItems":1}}},{"properties":{"publicationTargets":{"minItems":1}}}]},{"if":{"properties":{"capabilityStatus":{"const":"production-ready"}},"required":["capabilityStatus"]},"then":{"properties":{"targetOverlays":{"items":{"type":"object","properties":{"implementationStatus":{"const":"production-ready"}},"required":["implementationStatus"]}}}}},{"if":{"properties":{"layoutProfile":{"const":"flow-page"}},"required":["layoutProfile"]},"then":{"properties":{"layout":{"$ref":"#/$defs/FlowPageLayout"},"renderTargets":{"items":{"enum":["docx","hwpx","pdf"]}},"publicationTargets":{"items":{"const":"google-docs"}}}}},{"if":{"properties":{"layoutProfile":{"const":"fixed-page"}},"required":["layoutProfile"]},"then":{"properties":{"layout":{"$ref":"#/$defs/FixedPageLayout"},"renderTargets":{"items":{"enum":["pptx","pdf"]}},"publicationTargets":{"maxItems":0}}}},{"if":{"properties":{"layoutProfile":{"const":"workbook"}},"required":["layoutProfile"]},"then":{"properties":{"layout":{"$ref":"#/$defs/WorkbookLayout"},"renderTargets":{"minItems":1,"maxItems":2,"items":{"enum":["xlsx","pdf"]},"contains":{"const":"xlsx"}},"publicationTargets":{"maxItems":0}}}},{"if":{"properties":{"layoutProfile":{"const":"block-page"}},"required":["layoutProfile"]},"then":{"properties":{"layout":{"$ref":"#/$defs/BlockPageLayout"},"renderTargets":{"maxItems":0},"publicationTargets":{"minItems":1,"maxItems":1,"items":{"const":"notion"}}}}},{"if":{"properties":{"renderTargets":{"contains":{"const":"docx"}}},"required":["renderTargets"]},"then":{"properties":{"targetOverlays":{"contains":{"$ref":"#/$defs/DocxOverlaySelector"},"minContains":1,"maxContains":1}}},"else":{"properties":{"targetOverlays":{"not":{"contains":{"$ref":"#/$defs/DocxOverlaySelector"}}}}}},{"if":{"properties":{"renderTargets":{"contains":{"const":"hwpx"}}},"required":["renderTargets"]},"then":{"properties":{"targetOverlays":{"contains":{"$ref":"#/$defs/HwpxOverlaySelector"},"minContains":1,"maxContains":1}}},"else":{"properties":{"targetOverlays":{"not":{"contains":{"$ref":"#/$defs/HwpxOverlaySelector"}}}}}},{"if":{"properties":{"renderTargets":{"contains":{"const":"pptx"}}},"required":["renderTargets"]},"then":{"properties":{"targetOverlays":{"contains":{"$ref":"#/$defs/PptxOverlaySelector"},"minContains":1,"maxContains":1}}},"else":{"properties":{"targetOverlays":{"not":{"contains":{"$ref":"#/$defs/PptxOverlaySelector"}}}}}},{"if":{"properties":{"renderTargets":{"contains":{"const":"xlsx"}}},"required":["renderTargets"]},"then":{"properties":{"targetOverlays":{"contains":{"$ref":"#/$defs/XlsxOverlaySelector"},"minContains":1,"maxContains":1}}},"else":{"properties":{"targetOverlays":{"not":{"contains":{"$ref":"#/$defs/XlsxOverlaySelector"}}}}}},{"if":{"properties":{"renderTargets":{"contains":{"const":"pdf"}}},"required":["renderTargets"]},"then":{"properties":{"targetOverlays":{"contains":{"$ref":"#/$defs/PdfOverlaySelector"},"minContains":1,"maxContains":1}}},"else":{"properties":{"targetOverlays":{"not":{"contains":{"$ref":"#/$defs/PdfOverlaySelector"}}}}}},{"if":{"properties":{"publicationTargets":{"contains":{"const":"google-docs"}}},"required":["publicationTargets"]},"then":{"properties":{"targetOverlays":{"contains":{"$ref":"#/$defs/GoogleDocsOverlaySelector"},"minContains":1,"maxContains":1}}},"else":{"properties":{"targetOverlays":{"not":{"contains":{"$ref":"#/$defs/GoogleDocsOverlaySelector"}}}}}},{"if":{"properties":{"publicationTargets":{"contains":{"const":"notion"}}},"required":["publicationTargets"]},"then":{"properties":{"targetOverlays":{"contains":{"$ref":"#/$defs/NotionOverlaySelector"},"minContains":1,"maxContains":1}}},"else":{"properties":{"targetOverlays":{"not":{"contains":{"$ref":"#/$defs/NotionOverlaySelector"}}}}}}]}}};
const schema32 = {"type":"string","pattern":"^[a-z0-9]+(?:-[a-z0-9]+)*$"};
const schema33 = {"type":"string","pattern":"^[0-9]+\\.[0-9]+\\.[0-9]+$"};
const schema75 = {"type":"object","additionalProperties":false,"required":["humanPromotionRequired","automatedPromotionAllowed","modelMayApprove","evidenceRequired"],"properties":{"humanPromotionRequired":{"const":true},"automatedPromotionAllowed":{"const":false},"modelMayApprove":{"const":false},"evidenceRequired":{"const":true}}};
const func1 = Object.prototype.hasOwnProperty;
const func2 = ajvUcs2Length;
const pattern4 = new RegExp("^[a-z0-9]+(?:-[a-z0-9]+)*$", "u");
const pattern5 = new RegExp("^[0-9]+\\.[0-9]+\\.[0-9]+$", "u");
const schema34 = {"type":"object","additionalProperties":false,"required":["ownerRef","locale","tags"],"properties":{"ownerRef":{"$ref":"#/$defs/Reference"},"locale":{"type":"string","pattern":"^[a-z]{2,3}(?:-[A-Z]{2})?$"},"tags":{"type":"array","uniqueItems":true,"items":{"$ref":"#/$defs/KebabId"}}}};
const schema35 = {"type":"string","minLength":1};
const func0 = ajvEqual;
const pattern6 = new RegExp("^[a-z]{2,3}(?:-[A-Z]{2})?$", "u");

function validate21(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate21.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.ownerRef === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "ownerRef"},message:"must have required property '"+"ownerRef"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.locale === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "locale"},message:"must have required property '"+"locale"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.tags === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "tags"},message:"must have required property '"+"tags"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "ownerRef") || (key0 === "locale")) || (key0 === "tags"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.ownerRef !== undefined){
let data0 = data.ownerRef;
if(typeof data0 === "string"){
if(func2(data0) < 1){
const err4 = {instancePath:instancePath+"/ownerRef",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/ownerRef",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.locale !== undefined){
let data1 = data.locale;
if(typeof data1 === "string"){
if(!pattern6.test(data1)){
const err6 = {instancePath:instancePath+"/locale",schemaPath:"#/properties/locale/pattern",keyword:"pattern",params:{pattern: "^[a-z]{2,3}(?:-[A-Z]{2})?$"},message:"must match pattern \""+"^[a-z]{2,3}(?:-[A-Z]{2})?$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/locale",schemaPath:"#/properties/locale/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.tags !== undefined){
let data2 = data.tags;
if(Array.isArray(data2)){
const len0 = data2.length;
for(let i0=0; i0<len0; i0++){
let data3 = data2[i0];
if(typeof data3 === "string"){
if(!pattern4.test(data3)){
const err8 = {instancePath:instancePath+"/tags/" + i0,schemaPath:"#/$defs/KebabId/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9]+(?:-[a-z0-9]+)*$"},message:"must match pattern \""+"^[a-z0-9]+(?:-[a-z0-9]+)*$"+"\""};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/tags/" + i0,schemaPath:"#/$defs/KebabId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
let i1 = data2.length;
let j0;
if(i1 > 1){
outer0:
for(;i1--;){
for(j0 = i1; j0--;){
if(func0(data2[i1], data2[j0])){
const err10 = {instancePath:instancePath+"/tags",schemaPath:"#/properties/tags/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err11 = {instancePath:instancePath+"/tags",schemaPath:"#/properties/tags/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
else {
const err12 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
validate21.errors = vErrors;
return errors === 0;
}
validate21.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema37 = {"type":"object","additionalProperties":false,"required":["schemaVersion","templateId","templateVersion","manifestRef","manifestSha256"],"properties":{"schemaVersion":{"const":"cogo.document-template.v1"},"templateId":{"$ref":"#/$defs/KebabId"},"templateVersion":{"$ref":"#/$defs/Semver"},"manifestRef":{"$ref":"#/$defs/Reference"},"manifestSha256":{"$ref":"#/$defs/Sha256"}}};
const schema41 = {"type":"string","pattern":"^sha256:[a-f0-9]{64}$"};
const pattern10 = new RegExp("^sha256:[a-f0-9]{64}$", "u");

function validate23(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate23.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.schemaVersion === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "schemaVersion"},message:"must have required property '"+"schemaVersion"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.templateId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "templateId"},message:"must have required property '"+"templateId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.templateVersion === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "templateVersion"},message:"must have required property '"+"templateVersion"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.manifestRef === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "manifestRef"},message:"must have required property '"+"manifestRef"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.manifestSha256 === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "manifestSha256"},message:"must have required property '"+"manifestSha256"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "schemaVersion") || (key0 === "templateId")) || (key0 === "templateVersion")) || (key0 === "manifestRef")) || (key0 === "manifestSha256"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.schemaVersion !== undefined){
if("cogo.document-template.v1" !== data.schemaVersion){
const err6 = {instancePath:instancePath+"/schemaVersion",schemaPath:"#/properties/schemaVersion/const",keyword:"const",params:{allowedValue: "cogo.document-template.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.templateId !== undefined){
let data1 = data.templateId;
if(typeof data1 === "string"){
if(!pattern4.test(data1)){
const err7 = {instancePath:instancePath+"/templateId",schemaPath:"#/$defs/KebabId/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9]+(?:-[a-z0-9]+)*$"},message:"must match pattern \""+"^[a-z0-9]+(?:-[a-z0-9]+)*$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/templateId",schemaPath:"#/$defs/KebabId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.templateVersion !== undefined){
let data2 = data.templateVersion;
if(typeof data2 === "string"){
if(!pattern5.test(data2)){
const err9 = {instancePath:instancePath+"/templateVersion",schemaPath:"#/$defs/Semver/pattern",keyword:"pattern",params:{pattern: "^[0-9]+\\.[0-9]+\\.[0-9]+$"},message:"must match pattern \""+"^[0-9]+\\.[0-9]+\\.[0-9]+$"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/templateVersion",schemaPath:"#/$defs/Semver/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.manifestRef !== undefined){
let data3 = data.manifestRef;
if(typeof data3 === "string"){
if(func2(data3) < 1){
const err11 = {instancePath:instancePath+"/manifestRef",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/manifestRef",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.manifestSha256 !== undefined){
let data4 = data.manifestSha256;
if(typeof data4 === "string"){
if(!pattern10.test(data4)){
const err13 = {instancePath:instancePath+"/manifestSha256",schemaPath:"#/$defs/Sha256/pattern",keyword:"pattern",params:{pattern: "^sha256:[a-f0-9]{64}$"},message:"must match pattern \""+"^sha256:[a-f0-9]{64}$"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/manifestSha256",schemaPath:"#/$defs/Sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
else {
const err15 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
validate23.errors = vErrors;
return errors === 0;
}
validate23.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema42 = {"type":"object","additionalProperties":false,"required":["dataSchema","slots","tokens","assets","guidelineRefs","llmPolicy","actionFlowRefs","proofProfile","sourceProvenance"],"properties":{"dataSchema":{"$ref":"#/$defs/DataSchema"},"slots":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/SemanticSlot"}},"tokens":{"$ref":"#/$defs/Tokens"},"assets":{"type":"array","items":{"$ref":"#/$defs/Asset"}},"guidelineRefs":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/GuidelineRef"}},"llmPolicy":{"$ref":"#/$defs/LlmPolicy"},"actionFlowRefs":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/ActionFlowRef"}},"proofProfile":{"$ref":"#/$defs/ProofProfile"},"sourceProvenance":{"$ref":"#/$defs/SourceProvenance"}}};
const schema67 = {"type":"object","additionalProperties":false,"required":["allowedRoles","canonicalAuthority","finalWriterAllowed","outputRequiresValidation"],"properties":{"allowedRoles":{"type":"array","minItems":1,"uniqueItems":true,"items":{"enum":["semantic-input-assistant","layout-proposal-assistant","content-revision-assistant"]}},"canonicalAuthority":{"const":false},"finalWriterAllowed":{"const":false},"outputRequiresValidation":{"const":true}}};
const schema72 = {"type":"object","additionalProperties":false,"required":["requiredForPromotion","nativeStructureReadbackRequired","targetReadbackRequired","structureHashRequired","providerVersionPolicy","visualDiffPolicy","evidenceRetention"],"properties":{"requiredForPromotion":{"const":true},"nativeStructureReadbackRequired":{"const":true},"targetReadbackRequired":{"const":true},"structureHashRequired":{"const":true},"providerVersionPolicy":{"const":"required-when-provider"},"visualDiffPolicy":{"enum":["always","when-layout-bearing"]},"evidenceRetention":{"const":"immutable"}}};
const schema43 = {"type":"object","additionalProperties":false,"required":["ref"],"properties":{"ref":{"$ref":"#/$defs/Reference"},"sha256":{"$ref":"#/$defs/Sha256"}}};

function validate26(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate26.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.ref === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "ref"},message:"must have required property '"+"ref"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "ref") || (key0 === "sha256"))){
const err1 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.ref !== undefined){
let data0 = data.ref;
if(typeof data0 === "string"){
if(func2(data0) < 1){
const err2 = {instancePath:instancePath+"/ref",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
else {
const err3 = {instancePath:instancePath+"/ref",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.sha256 !== undefined){
let data1 = data.sha256;
if(typeof data1 === "string"){
if(!pattern10.test(data1)){
const err4 = {instancePath:instancePath+"/sha256",schemaPath:"#/$defs/Sha256/pattern",keyword:"pattern",params:{pattern: "^sha256:[a-f0-9]{64}$"},message:"must match pattern \""+"^sha256:[a-f0-9]{64}$"+"\""};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/sha256",schemaPath:"#/$defs/Sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
else {
const err6 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
validate26.errors = vErrors;
return errors === 0;
}
validate26.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema46 = {"oneOf":[{"$ref":"#/$defs/ReferencedSemanticSlot"},{"$ref":"#/$defs/InlineSemanticSlot"}]};
const schema47 = {"type":"object","additionalProperties":false,"required":["id","slotRef","kind","required","semanticRole"],"properties":{"id":{"$ref":"#/$defs/KebabId"},"slotRef":{"$ref":"#/$defs/Reference"},"kind":{"$ref":"#/$defs/SemanticSlotKind"},"required":{"type":"boolean"},"semanticRole":{"$ref":"#/$defs/KebabId"}}};
const schema50 = {"enum":["scalar","rich-text","table","image","chart","repeated-group","formula-input","provider-property"]};

function validate29(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate29.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.slotRef === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "slotRef"},message:"must have required property '"+"slotRef"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.kind === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.required === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "required"},message:"must have required property '"+"required"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.semanticRole === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "semanticRole"},message:"must have required property '"+"semanticRole"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "id") || (key0 === "slotRef")) || (key0 === "kind")) || (key0 === "required")) || (key0 === "semanticRole"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(!pattern4.test(data0)){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/KebabId/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9]+(?:-[a-z0-9]+)*$"},message:"must match pattern \""+"^[a-z0-9]+(?:-[a-z0-9]+)*$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/KebabId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.slotRef !== undefined){
let data1 = data.slotRef;
if(typeof data1 === "string"){
if(func2(data1) < 1){
const err8 = {instancePath:instancePath+"/slotRef",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/slotRef",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.kind !== undefined){
let data2 = data.kind;
if(!((((((((data2 === "scalar") || (data2 === "rich-text")) || (data2 === "table")) || (data2 === "image")) || (data2 === "chart")) || (data2 === "repeated-group")) || (data2 === "formula-input")) || (data2 === "provider-property"))){
const err10 = {instancePath:instancePath+"/kind",schemaPath:"#/$defs/SemanticSlotKind/enum",keyword:"enum",params:{allowedValues: schema50.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.required !== undefined){
if(typeof data.required !== "boolean"){
const err11 = {instancePath:instancePath+"/required",schemaPath:"#/properties/required/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.semanticRole !== undefined){
let data4 = data.semanticRole;
if(typeof data4 === "string"){
if(!pattern4.test(data4)){
const err12 = {instancePath:instancePath+"/semanticRole",schemaPath:"#/$defs/KebabId/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9]+(?:-[a-z0-9]+)*$"},message:"must match pattern \""+"^[a-z0-9]+(?:-[a-z0-9]+)*$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/semanticRole",schemaPath:"#/$defs/KebabId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
else {
const err14 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
validate29.errors = vErrors;
return errors === 0;
}
validate29.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema52 = {"type":"object","additionalProperties":false,"required":["id","kind","bindingPath","required","semanticRole"],"properties":{"id":{"$ref":"#/$defs/KebabId"},"kind":{"$ref":"#/$defs/SemanticSlotKind"},"bindingPath":{"type":"string","pattern":"^/(?:[^/~]|~[01])+(?:/(?:[^/~]|~[01])+)*$"},"required":{"type":"boolean"},"semanticRole":{"$ref":"#/$defs/KebabId"},"shapeRef":{"$ref":"#/$defs/Reference"}}};
const pattern15 = new RegExp("^/(?:[^/~]|~[01])+(?:/(?:[^/~]|~[01])+)*$", "u");

function validate31(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate31.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.kind === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.bindingPath === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "bindingPath"},message:"must have required property '"+"bindingPath"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.required === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "required"},message:"must have required property '"+"required"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.semanticRole === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "semanticRole"},message:"must have required property '"+"semanticRole"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "id") || (key0 === "kind")) || (key0 === "bindingPath")) || (key0 === "required")) || (key0 === "semanticRole")) || (key0 === "shapeRef"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(!pattern4.test(data0)){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/KebabId/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9]+(?:-[a-z0-9]+)*$"},message:"must match pattern \""+"^[a-z0-9]+(?:-[a-z0-9]+)*$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/KebabId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.kind !== undefined){
let data1 = data.kind;
if(!((((((((data1 === "scalar") || (data1 === "rich-text")) || (data1 === "table")) || (data1 === "image")) || (data1 === "chart")) || (data1 === "repeated-group")) || (data1 === "formula-input")) || (data1 === "provider-property"))){
const err8 = {instancePath:instancePath+"/kind",schemaPath:"#/$defs/SemanticSlotKind/enum",keyword:"enum",params:{allowedValues: schema50.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.bindingPath !== undefined){
let data2 = data.bindingPath;
if(typeof data2 === "string"){
if(!pattern15.test(data2)){
const err9 = {instancePath:instancePath+"/bindingPath",schemaPath:"#/properties/bindingPath/pattern",keyword:"pattern",params:{pattern: "^/(?:[^/~]|~[01])+(?:/(?:[^/~]|~[01])+)*$"},message:"must match pattern \""+"^/(?:[^/~]|~[01])+(?:/(?:[^/~]|~[01])+)*$"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/bindingPath",schemaPath:"#/properties/bindingPath/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.required !== undefined){
if(typeof data.required !== "boolean"){
const err11 = {instancePath:instancePath+"/required",schemaPath:"#/properties/required/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.semanticRole !== undefined){
let data4 = data.semanticRole;
if(typeof data4 === "string"){
if(!pattern4.test(data4)){
const err12 = {instancePath:instancePath+"/semanticRole",schemaPath:"#/$defs/KebabId/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9]+(?:-[a-z0-9]+)*$"},message:"must match pattern \""+"^[a-z0-9]+(?:-[a-z0-9]+)*$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/semanticRole",schemaPath:"#/$defs/KebabId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.shapeRef !== undefined){
let data5 = data.shapeRef;
if(typeof data5 === "string"){
if(func2(data5) < 1){
const err14 = {instancePath:instancePath+"/shapeRef",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/shapeRef",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
else {
const err16 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
validate31.errors = vErrors;
return errors === 0;
}
validate31.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate28(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate28.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(!(validate29(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate29.errors : vErrors.concat(validate29.errors);
errors = vErrors.length;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs2 = errors;
if(!(validate31(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate31.errors : vErrors.concat(validate31.errors);
errors = vErrors.length;
}
var _valid0 = _errs2 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
}
if(!valid0){
const err0 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate28.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate28.evaluated = {"dynamicProps":true,"dynamicItems":false};

const schema57 = {"type":"object","additionalProperties":false,"required":["designTokenRefs"],"properties":{"designTokenRefs":{"type":"array","minItems":1,"uniqueItems":true,"items":{"$ref":"#/$defs/Reference"}}}};

function validate34(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate34.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.designTokenRefs === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "designTokenRefs"},message:"must have required property '"+"designTokenRefs"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(key0 === "designTokenRefs")){
const err1 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.designTokenRefs !== undefined){
let data0 = data.designTokenRefs;
if(Array.isArray(data0)){
if(data0.length < 1){
const err2 = {instancePath:instancePath+"/designTokenRefs",schemaPath:"#/properties/designTokenRefs/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
let data1 = data0[i0];
if(typeof data1 === "string"){
if(func2(data1) < 1){
const err3 = {instancePath:instancePath+"/designTokenRefs/" + i0,schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
else {
const err4 = {instancePath:instancePath+"/designTokenRefs/" + i0,schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
let i1 = data0.length;
let j0;
if(i1 > 1){
outer0:
for(;i1--;){
for(j0 = i1; j0--;){
if(func0(data0[i1], data0[j0])){
const err5 = {instancePath:instancePath+"/designTokenRefs",schemaPath:"#/properties/designTokenRefs/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err6 = {instancePath:instancePath+"/designTokenRefs",schemaPath:"#/properties/designTokenRefs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
}
else {
const err7 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
validate34.errors = vErrors;
return errors === 0;
}
validate34.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema59 = {"type":"object","additionalProperties":false,"required":["id","role","sourceRef","mediaType"],"properties":{"id":{"$ref":"#/$defs/KebabId"},"role":{"$ref":"#/$defs/KebabId"},"sourceRef":{"$ref":"#/$defs/Reference"},"mediaType":{"type":"string","minLength":1},"sha256":{"$ref":"#/$defs/Sha256"}}};

function validate36(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate36.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.role === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "role"},message:"must have required property '"+"role"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.sourceRef === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sourceRef"},message:"must have required property '"+"sourceRef"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.mediaType === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "mediaType"},message:"must have required property '"+"mediaType"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "id") || (key0 === "role")) || (key0 === "sourceRef")) || (key0 === "mediaType")) || (key0 === "sha256"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(!pattern4.test(data0)){
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/KebabId/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9]+(?:-[a-z0-9]+)*$"},message:"must match pattern \""+"^[a-z0-9]+(?:-[a-z0-9]+)*$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/KebabId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.role !== undefined){
let data1 = data.role;
if(typeof data1 === "string"){
if(!pattern4.test(data1)){
const err7 = {instancePath:instancePath+"/role",schemaPath:"#/$defs/KebabId/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9]+(?:-[a-z0-9]+)*$"},message:"must match pattern \""+"^[a-z0-9]+(?:-[a-z0-9]+)*$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/role",schemaPath:"#/$defs/KebabId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.sourceRef !== undefined){
let data2 = data.sourceRef;
if(typeof data2 === "string"){
if(func2(data2) < 1){
const err9 = {instancePath:instancePath+"/sourceRef",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/sourceRef",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.mediaType !== undefined){
let data3 = data.mediaType;
if(typeof data3 === "string"){
if(func2(data3) < 1){
const err11 = {instancePath:instancePath+"/mediaType",schemaPath:"#/properties/mediaType/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/mediaType",schemaPath:"#/properties/mediaType/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.sha256 !== undefined){
let data4 = data.sha256;
if(typeof data4 === "string"){
if(!pattern10.test(data4)){
const err13 = {instancePath:instancePath+"/sha256",schemaPath:"#/$defs/Sha256/pattern",keyword:"pattern",params:{pattern: "^sha256:[a-f0-9]{64}$"},message:"must match pattern \""+"^sha256:[a-f0-9]{64}$"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/sha256",schemaPath:"#/$defs/Sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
else {
const err15 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
validate36.errors = vErrors;
return errors === 0;
}
validate36.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema64 = {"type":"object","additionalProperties":false,"required":["ref","required"],"properties":{"ref":{"$ref":"#/$defs/Reference"},"required":{"type":"boolean"},"sha256":{"$ref":"#/$defs/Sha256"}}};

function validate38(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate38.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.ref === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "ref"},message:"must have required property '"+"ref"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.required === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "required"},message:"must have required property '"+"required"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "ref") || (key0 === "required")) || (key0 === "sha256"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.ref !== undefined){
let data0 = data.ref;
if(typeof data0 === "string"){
if(func2(data0) < 1){
const err3 = {instancePath:instancePath+"/ref",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
else {
const err4 = {instancePath:instancePath+"/ref",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.required !== undefined){
if(typeof data.required !== "boolean"){
const err5 = {instancePath:instancePath+"/required",schemaPath:"#/properties/required/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.sha256 !== undefined){
let data2 = data.sha256;
if(typeof data2 === "string"){
if(!pattern10.test(data2)){
const err6 = {instancePath:instancePath+"/sha256",schemaPath:"#/$defs/Sha256/pattern",keyword:"pattern",params:{pattern: "^sha256:[a-f0-9]{64}$"},message:"must match pattern \""+"^sha256:[a-f0-9]{64}$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/sha256",schemaPath:"#/$defs/Sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
validate38.errors = vErrors;
return errors === 0;
}
validate38.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema68 = {"type":"object","additionalProperties":false,"required":["id","ref","role"],"properties":{"id":{"$ref":"#/$defs/KebabId"},"ref":{"$ref":"#/$defs/Reference"},"role":{"enum":["generation","approval","refresh","export","publication","interaction"]},"sha256":{"$ref":"#/$defs/Sha256"}}};

function validate40(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate40.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.ref === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "ref"},message:"must have required property '"+"ref"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.role === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "role"},message:"must have required property '"+"role"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "id") || (key0 === "ref")) || (key0 === "role")) || (key0 === "sha256"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(!pattern4.test(data0)){
const err4 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/KebabId/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9]+(?:-[a-z0-9]+)*$"},message:"must match pattern \""+"^[a-z0-9]+(?:-[a-z0-9]+)*$"+"\""};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/KebabId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.ref !== undefined){
let data1 = data.ref;
if(typeof data1 === "string"){
if(func2(data1) < 1){
const err6 = {instancePath:instancePath+"/ref",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/ref",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.role !== undefined){
let data2 = data.role;
if(!((((((data2 === "generation") || (data2 === "approval")) || (data2 === "refresh")) || (data2 === "export")) || (data2 === "publication")) || (data2 === "interaction"))){
const err8 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/enum",keyword:"enum",params:{allowedValues: schema68.properties.role.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.sha256 !== undefined){
let data3 = data.sha256;
if(typeof data3 === "string"){
if(!pattern10.test(data3)){
const err9 = {instancePath:instancePath+"/sha256",schemaPath:"#/$defs/Sha256/pattern",keyword:"pattern",params:{pattern: "^sha256:[a-f0-9]{64}$"},message:"must match pattern \""+"^sha256:[a-f0-9]{64}$"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/sha256",schemaPath:"#/$defs/Sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
else {
const err11 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
validate40.errors = vErrors;
return errors === 0;
}
validate40.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema73 = {"type":"object","additionalProperties":false,"required":["required","sourceRefs","preserveProviderVersion","sourceAdaptersCanonical"],"properties":{"required":{"const":true},"sourceRefs":{"type":"array","minItems":1,"uniqueItems":true,"items":{"$ref":"#/$defs/Reference"}},"preserveProviderVersion":{"const":true},"sourceAdaptersCanonical":{"const":false}}};

function validate42(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate42.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.required === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "required"},message:"must have required property '"+"required"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.sourceRefs === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sourceRefs"},message:"must have required property '"+"sourceRefs"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.preserveProviderVersion === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "preserveProviderVersion"},message:"must have required property '"+"preserveProviderVersion"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.sourceAdaptersCanonical === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sourceAdaptersCanonical"},message:"must have required property '"+"sourceAdaptersCanonical"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "required") || (key0 === "sourceRefs")) || (key0 === "preserveProviderVersion")) || (key0 === "sourceAdaptersCanonical"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.required !== undefined){
if(true !== data.required){
const err5 = {instancePath:instancePath+"/required",schemaPath:"#/properties/required/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.sourceRefs !== undefined){
let data1 = data.sourceRefs;
if(Array.isArray(data1)){
if(data1.length < 1){
const err6 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/properties/sourceRefs/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
let data2 = data1[i0];
if(typeof data2 === "string"){
if(func2(data2) < 1){
const err7 = {instancePath:instancePath+"/sourceRefs/" + i0,schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/sourceRefs/" + i0,schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
let i1 = data1.length;
let j0;
if(i1 > 1){
outer0:
for(;i1--;){
for(j0 = i1; j0--;){
if(func0(data1[i1], data1[j0])){
const err9 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/properties/sourceRefs/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err10 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/properties/sourceRefs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.preserveProviderVersion !== undefined){
if(true !== data.preserveProviderVersion){
const err11 = {instancePath:instancePath+"/preserveProviderVersion",schemaPath:"#/properties/preserveProviderVersion/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.sourceAdaptersCanonical !== undefined){
if(false !== data.sourceAdaptersCanonical){
const err12 = {instancePath:instancePath+"/sourceAdaptersCanonical",schemaPath:"#/properties/sourceAdaptersCanonical/const",keyword:"const",params:{allowedValue: false},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
}
else {
const err13 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
validate42.errors = vErrors;
return errors === 0;
}
validate42.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate25(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate25.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.dataSchema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "dataSchema"},message:"must have required property '"+"dataSchema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.slots === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "slots"},message:"must have required property '"+"slots"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.tokens === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "tokens"},message:"must have required property '"+"tokens"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.assets === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assets"},message:"must have required property '"+"assets"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.guidelineRefs === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "guidelineRefs"},message:"must have required property '"+"guidelineRefs"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.llmPolicy === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "llmPolicy"},message:"must have required property '"+"llmPolicy"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.actionFlowRefs === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "actionFlowRefs"},message:"must have required property '"+"actionFlowRefs"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.proofProfile === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "proofProfile"},message:"must have required property '"+"proofProfile"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.sourceProvenance === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sourceProvenance"},message:"must have required property '"+"sourceProvenance"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema42.properties, key0))){
const err9 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.dataSchema !== undefined){
if(!(validate26(data.dataSchema, {instancePath:instancePath+"/dataSchema",parentData:data,parentDataProperty:"dataSchema",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate26.errors : vErrors.concat(validate26.errors);
errors = vErrors.length;
}
}
if(data.slots !== undefined){
let data1 = data.slots;
if(Array.isArray(data1)){
if(data1.length < 1){
const err10 = {instancePath:instancePath+"/slots",schemaPath:"#/properties/slots/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
if(!(validate28(data1[i0], {instancePath:instancePath+"/slots/" + i0,parentData:data1,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate28.errors : vErrors.concat(validate28.errors);
errors = vErrors.length;
}
}
}
else {
const err11 = {instancePath:instancePath+"/slots",schemaPath:"#/properties/slots/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.tokens !== undefined){
if(!(validate34(data.tokens, {instancePath:instancePath+"/tokens",parentData:data,parentDataProperty:"tokens",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate34.errors : vErrors.concat(validate34.errors);
errors = vErrors.length;
}
}
if(data.assets !== undefined){
let data4 = data.assets;
if(Array.isArray(data4)){
const len1 = data4.length;
for(let i1=0; i1<len1; i1++){
if(!(validate36(data4[i1], {instancePath:instancePath+"/assets/" + i1,parentData:data4,parentDataProperty:i1,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate36.errors : vErrors.concat(validate36.errors);
errors = vErrors.length;
}
}
}
else {
const err12 = {instancePath:instancePath+"/assets",schemaPath:"#/properties/assets/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.guidelineRefs !== undefined){
let data6 = data.guidelineRefs;
if(Array.isArray(data6)){
if(data6.length < 1){
const err13 = {instancePath:instancePath+"/guidelineRefs",schemaPath:"#/properties/guidelineRefs/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
const len2 = data6.length;
for(let i2=0; i2<len2; i2++){
if(!(validate38(data6[i2], {instancePath:instancePath+"/guidelineRefs/" + i2,parentData:data6,parentDataProperty:i2,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate38.errors : vErrors.concat(validate38.errors);
errors = vErrors.length;
}
}
}
else {
const err14 = {instancePath:instancePath+"/guidelineRefs",schemaPath:"#/properties/guidelineRefs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.llmPolicy !== undefined){
let data8 = data.llmPolicy;
if(data8 && typeof data8 == "object" && !Array.isArray(data8)){
if(data8.allowedRoles === undefined){
const err15 = {instancePath:instancePath+"/llmPolicy",schemaPath:"#/$defs/LlmPolicy/required",keyword:"required",params:{missingProperty: "allowedRoles"},message:"must have required property '"+"allowedRoles"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data8.canonicalAuthority === undefined){
const err16 = {instancePath:instancePath+"/llmPolicy",schemaPath:"#/$defs/LlmPolicy/required",keyword:"required",params:{missingProperty: "canonicalAuthority"},message:"must have required property '"+"canonicalAuthority"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data8.finalWriterAllowed === undefined){
const err17 = {instancePath:instancePath+"/llmPolicy",schemaPath:"#/$defs/LlmPolicy/required",keyword:"required",params:{missingProperty: "finalWriterAllowed"},message:"must have required property '"+"finalWriterAllowed"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data8.outputRequiresValidation === undefined){
const err18 = {instancePath:instancePath+"/llmPolicy",schemaPath:"#/$defs/LlmPolicy/required",keyword:"required",params:{missingProperty: "outputRequiresValidation"},message:"must have required property '"+"outputRequiresValidation"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
for(const key1 in data8){
if(!((((key1 === "allowedRoles") || (key1 === "canonicalAuthority")) || (key1 === "finalWriterAllowed")) || (key1 === "outputRequiresValidation"))){
const err19 = {instancePath:instancePath+"/llmPolicy",schemaPath:"#/$defs/LlmPolicy/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data8.allowedRoles !== undefined){
let data9 = data8.allowedRoles;
if(Array.isArray(data9)){
if(data9.length < 1){
const err20 = {instancePath:instancePath+"/llmPolicy/allowedRoles",schemaPath:"#/$defs/LlmPolicy/properties/allowedRoles/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
const len3 = data9.length;
for(let i3=0; i3<len3; i3++){
let data10 = data9[i3];
if(!(((data10 === "semantic-input-assistant") || (data10 === "layout-proposal-assistant")) || (data10 === "content-revision-assistant"))){
const err21 = {instancePath:instancePath+"/llmPolicy/allowedRoles/" + i3,schemaPath:"#/$defs/LlmPolicy/properties/allowedRoles/items/enum",keyword:"enum",params:{allowedValues: schema67.properties.allowedRoles.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
let i4 = data9.length;
let j0;
if(i4 > 1){
outer0:
for(;i4--;){
for(j0 = i4; j0--;){
if(func0(data9[i4], data9[j0])){
const err22 = {instancePath:instancePath+"/llmPolicy/allowedRoles",schemaPath:"#/$defs/LlmPolicy/properties/allowedRoles/uniqueItems",keyword:"uniqueItems",params:{i: i4, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i4+" are identical)"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err23 = {instancePath:instancePath+"/llmPolicy/allowedRoles",schemaPath:"#/$defs/LlmPolicy/properties/allowedRoles/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data8.canonicalAuthority !== undefined){
if(false !== data8.canonicalAuthority){
const err24 = {instancePath:instancePath+"/llmPolicy/canonicalAuthority",schemaPath:"#/$defs/LlmPolicy/properties/canonicalAuthority/const",keyword:"const",params:{allowedValue: false},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data8.finalWriterAllowed !== undefined){
if(false !== data8.finalWriterAllowed){
const err25 = {instancePath:instancePath+"/llmPolicy/finalWriterAllowed",schemaPath:"#/$defs/LlmPolicy/properties/finalWriterAllowed/const",keyword:"const",params:{allowedValue: false},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data8.outputRequiresValidation !== undefined){
if(true !== data8.outputRequiresValidation){
const err26 = {instancePath:instancePath+"/llmPolicy/outputRequiresValidation",schemaPath:"#/$defs/LlmPolicy/properties/outputRequiresValidation/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
else {
const err27 = {instancePath:instancePath+"/llmPolicy",schemaPath:"#/$defs/LlmPolicy/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data.actionFlowRefs !== undefined){
let data14 = data.actionFlowRefs;
if(Array.isArray(data14)){
if(data14.length < 1){
const err28 = {instancePath:instancePath+"/actionFlowRefs",schemaPath:"#/properties/actionFlowRefs/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
const len4 = data14.length;
for(let i5=0; i5<len4; i5++){
if(!(validate40(data14[i5], {instancePath:instancePath+"/actionFlowRefs/" + i5,parentData:data14,parentDataProperty:i5,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate40.errors : vErrors.concat(validate40.errors);
errors = vErrors.length;
}
}
}
else {
const err29 = {instancePath:instancePath+"/actionFlowRefs",schemaPath:"#/properties/actionFlowRefs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data.proofProfile !== undefined){
let data16 = data.proofProfile;
if(data16 && typeof data16 == "object" && !Array.isArray(data16)){
if(data16.requiredForPromotion === undefined){
const err30 = {instancePath:instancePath+"/proofProfile",schemaPath:"#/$defs/ProofProfile/required",keyword:"required",params:{missingProperty: "requiredForPromotion"},message:"must have required property '"+"requiredForPromotion"+"'"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if(data16.nativeStructureReadbackRequired === undefined){
const err31 = {instancePath:instancePath+"/proofProfile",schemaPath:"#/$defs/ProofProfile/required",keyword:"required",params:{missingProperty: "nativeStructureReadbackRequired"},message:"must have required property '"+"nativeStructureReadbackRequired"+"'"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data16.targetReadbackRequired === undefined){
const err32 = {instancePath:instancePath+"/proofProfile",schemaPath:"#/$defs/ProofProfile/required",keyword:"required",params:{missingProperty: "targetReadbackRequired"},message:"must have required property '"+"targetReadbackRequired"+"'"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if(data16.structureHashRequired === undefined){
const err33 = {instancePath:instancePath+"/proofProfile",schemaPath:"#/$defs/ProofProfile/required",keyword:"required",params:{missingProperty: "structureHashRequired"},message:"must have required property '"+"structureHashRequired"+"'"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if(data16.providerVersionPolicy === undefined){
const err34 = {instancePath:instancePath+"/proofProfile",schemaPath:"#/$defs/ProofProfile/required",keyword:"required",params:{missingProperty: "providerVersionPolicy"},message:"must have required property '"+"providerVersionPolicy"+"'"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(data16.visualDiffPolicy === undefined){
const err35 = {instancePath:instancePath+"/proofProfile",schemaPath:"#/$defs/ProofProfile/required",keyword:"required",params:{missingProperty: "visualDiffPolicy"},message:"must have required property '"+"visualDiffPolicy"+"'"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(data16.evidenceRetention === undefined){
const err36 = {instancePath:instancePath+"/proofProfile",schemaPath:"#/$defs/ProofProfile/required",keyword:"required",params:{missingProperty: "evidenceRetention"},message:"must have required property '"+"evidenceRetention"+"'"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
for(const key2 in data16){
if(!(((((((key2 === "requiredForPromotion") || (key2 === "nativeStructureReadbackRequired")) || (key2 === "targetReadbackRequired")) || (key2 === "structureHashRequired")) || (key2 === "providerVersionPolicy")) || (key2 === "visualDiffPolicy")) || (key2 === "evidenceRetention"))){
const err37 = {instancePath:instancePath+"/proofProfile",schemaPath:"#/$defs/ProofProfile/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
if(data16.requiredForPromotion !== undefined){
if(true !== data16.requiredForPromotion){
const err38 = {instancePath:instancePath+"/proofProfile/requiredForPromotion",schemaPath:"#/$defs/ProofProfile/properties/requiredForPromotion/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data16.nativeStructureReadbackRequired !== undefined){
if(true !== data16.nativeStructureReadbackRequired){
const err39 = {instancePath:instancePath+"/proofProfile/nativeStructureReadbackRequired",schemaPath:"#/$defs/ProofProfile/properties/nativeStructureReadbackRequired/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
if(data16.targetReadbackRequired !== undefined){
if(true !== data16.targetReadbackRequired){
const err40 = {instancePath:instancePath+"/proofProfile/targetReadbackRequired",schemaPath:"#/$defs/ProofProfile/properties/targetReadbackRequired/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
if(data16.structureHashRequired !== undefined){
if(true !== data16.structureHashRequired){
const err41 = {instancePath:instancePath+"/proofProfile/structureHashRequired",schemaPath:"#/$defs/ProofProfile/properties/structureHashRequired/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
if(data16.providerVersionPolicy !== undefined){
if("required-when-provider" !== data16.providerVersionPolicy){
const err42 = {instancePath:instancePath+"/proofProfile/providerVersionPolicy",schemaPath:"#/$defs/ProofProfile/properties/providerVersionPolicy/const",keyword:"const",params:{allowedValue: "required-when-provider"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
if(data16.visualDiffPolicy !== undefined){
let data22 = data16.visualDiffPolicy;
if(!((data22 === "always") || (data22 === "when-layout-bearing"))){
const err43 = {instancePath:instancePath+"/proofProfile/visualDiffPolicy",schemaPath:"#/$defs/ProofProfile/properties/visualDiffPolicy/enum",keyword:"enum",params:{allowedValues: schema72.properties.visualDiffPolicy.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
if(data16.evidenceRetention !== undefined){
if("immutable" !== data16.evidenceRetention){
const err44 = {instancePath:instancePath+"/proofProfile/evidenceRetention",schemaPath:"#/$defs/ProofProfile/properties/evidenceRetention/const",keyword:"const",params:{allowedValue: "immutable"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
}
else {
const err45 = {instancePath:instancePath+"/proofProfile",schemaPath:"#/$defs/ProofProfile/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
if(data.sourceProvenance !== undefined){
if(!(validate42(data.sourceProvenance, {instancePath:instancePath+"/sourceProvenance",parentData:data,parentDataProperty:"sourceProvenance",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate42.errors : vErrors.concat(validate42.errors);
errors = vErrors.length;
}
}
}
else {
const err46 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
validate25.errors = vErrors;
return errors === 0;
}
validate25.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema76 = {"type":"object","additionalProperties":false,"required":["variantId","name","layoutProfile","capabilityStatus","knownLimitations","layout","sourcePolicy","slotBindings","approvedOmissions","renderTargets","publicationTargets","targetOverlays"],"properties":{"variantId":{"$ref":"#/$defs/KebabId"},"name":{"type":"string","minLength":1},"layoutProfile":{"enum":["flow-page","fixed-page","workbook","block-page"]},"capabilityStatus":{"enum":["production-ready","partial","planned"]},"knownLimitations":{"type":"array","uniqueItems":true,"items":{"type":"string","minLength":1}},"layout":{"oneOf":[{"$ref":"#/$defs/FlowPageLayout"},{"$ref":"#/$defs/FixedPageLayout"},{"$ref":"#/$defs/WorkbookLayout"},{"$ref":"#/$defs/BlockPageLayout"}]},"sourcePolicy":{"$ref":"#/$defs/SourcePolicy"},"slotBindings":{"type":"array","items":{"$ref":"#/$defs/SlotBinding"}},"approvedOmissions":{"type":"array","items":{"$ref":"#/$defs/ApprovedOmission"}},"renderTargets":{"type":"array","uniqueItems":true,"items":{"enum":["docx","hwpx","pptx","xlsx","pdf"]}},"publicationTargets":{"type":"array","uniqueItems":true,"items":{"enum":["google-docs","notion"]}},"targetOverlays":{"type":"array","minItems":1,"uniqueItems":true,"items":{"$ref":"#/$defs/TargetOverlay"}}},"allOf":[{"anyOf":[{"properties":{"renderTargets":{"minItems":1}}},{"properties":{"publicationTargets":{"minItems":1}}}]},{"if":{"properties":{"capabilityStatus":{"const":"production-ready"}},"required":["capabilityStatus"]},"then":{"properties":{"targetOverlays":{"items":{"type":"object","properties":{"implementationStatus":{"const":"production-ready"}},"required":["implementationStatus"]}}}}},{"if":{"properties":{"layoutProfile":{"const":"flow-page"}},"required":["layoutProfile"]},"then":{"properties":{"layout":{"$ref":"#/$defs/FlowPageLayout"},"renderTargets":{"items":{"enum":["docx","hwpx","pdf"]}},"publicationTargets":{"items":{"const":"google-docs"}}}}},{"if":{"properties":{"layoutProfile":{"const":"fixed-page"}},"required":["layoutProfile"]},"then":{"properties":{"layout":{"$ref":"#/$defs/FixedPageLayout"},"renderTargets":{"items":{"enum":["pptx","pdf"]}},"publicationTargets":{"maxItems":0}}}},{"if":{"properties":{"layoutProfile":{"const":"workbook"}},"required":["layoutProfile"]},"then":{"properties":{"layout":{"$ref":"#/$defs/WorkbookLayout"},"renderTargets":{"minItems":1,"maxItems":2,"items":{"enum":["xlsx","pdf"]},"contains":{"const":"xlsx"}},"publicationTargets":{"maxItems":0}}}},{"if":{"properties":{"layoutProfile":{"const":"block-page"}},"required":["layoutProfile"]},"then":{"properties":{"layout":{"$ref":"#/$defs/BlockPageLayout"},"renderTargets":{"maxItems":0},"publicationTargets":{"minItems":1,"maxItems":1,"items":{"const":"notion"}}}}},{"if":{"properties":{"renderTargets":{"contains":{"const":"docx"}}},"required":["renderTargets"]},"then":{"properties":{"targetOverlays":{"contains":{"$ref":"#/$defs/DocxOverlaySelector"},"minContains":1,"maxContains":1}}},"else":{"properties":{"targetOverlays":{"not":{"contains":{"$ref":"#/$defs/DocxOverlaySelector"}}}}}},{"if":{"properties":{"renderTargets":{"contains":{"const":"hwpx"}}},"required":["renderTargets"]},"then":{"properties":{"targetOverlays":{"contains":{"$ref":"#/$defs/HwpxOverlaySelector"},"minContains":1,"maxContains":1}}},"else":{"properties":{"targetOverlays":{"not":{"contains":{"$ref":"#/$defs/HwpxOverlaySelector"}}}}}},{"if":{"properties":{"renderTargets":{"contains":{"const":"pptx"}}},"required":["renderTargets"]},"then":{"properties":{"targetOverlays":{"contains":{"$ref":"#/$defs/PptxOverlaySelector"},"minContains":1,"maxContains":1}}},"else":{"properties":{"targetOverlays":{"not":{"contains":{"$ref":"#/$defs/PptxOverlaySelector"}}}}}},{"if":{"properties":{"renderTargets":{"contains":{"const":"xlsx"}}},"required":["renderTargets"]},"then":{"properties":{"targetOverlays":{"contains":{"$ref":"#/$defs/XlsxOverlaySelector"},"minContains":1,"maxContains":1}}},"else":{"properties":{"targetOverlays":{"not":{"contains":{"$ref":"#/$defs/XlsxOverlaySelector"}}}}}},{"if":{"properties":{"renderTargets":{"contains":{"const":"pdf"}}},"required":["renderTargets"]},"then":{"properties":{"targetOverlays":{"contains":{"$ref":"#/$defs/PdfOverlaySelector"},"minContains":1,"maxContains":1}}},"else":{"properties":{"targetOverlays":{"not":{"contains":{"$ref":"#/$defs/PdfOverlaySelector"}}}}}},{"if":{"properties":{"publicationTargets":{"contains":{"const":"google-docs"}}},"required":["publicationTargets"]},"then":{"properties":{"targetOverlays":{"contains":{"$ref":"#/$defs/GoogleDocsOverlaySelector"},"minContains":1,"maxContains":1}}},"else":{"properties":{"targetOverlays":{"not":{"contains":{"$ref":"#/$defs/GoogleDocsOverlaySelector"}}}}}},{"if":{"properties":{"publicationTargets":{"contains":{"const":"notion"}}},"required":["publicationTargets"]},"then":{"properties":{"targetOverlays":{"contains":{"$ref":"#/$defs/NotionOverlaySelector"},"minContains":1,"maxContains":1}}},"else":{"properties":{"targetOverlays":{"not":{"contains":{"$ref":"#/$defs/NotionOverlaySelector"}}}}}}]};
const schema86 = {"type":"object","required":["target"],"properties":{"target":{"const":"docx"}}};
const schema88 = {"type":"object","required":["target"],"properties":{"target":{"const":"hwpx"}}};
const schema90 = {"type":"object","required":["target"],"properties":{"target":{"const":"pptx"}}};
const schema92 = {"type":"object","required":["target"],"properties":{"target":{"const":"xlsx"}}};
const schema94 = {"type":"object","required":["target"],"properties":{"target":{"const":"pdf"}}};
const schema96 = {"type":"object","required":["target"],"properties":{"target":{"const":"google-docs"}}};
const schema98 = {"type":"object","required":["target"],"properties":{"target":{"const":"notion"}}};
const schema101 = {"type":"object","additionalProperties":false,"required":["canonicalModel","editorAdapters","adapterCanonicalAuthority"],"properties":{"canonicalModel":{"const":"cogo-document-template-family"},"editorAdapters":{"type":"array","minItems":1,"uniqueItems":true,"items":{"enum":["wordgard","cogo-fixed-page-editor","univer","cogo-block-editor","openpencil","google-docs","notion"]}},"adapterCanonicalAuthority":{"const":false}}};
const schema77 = {"type":"object","additionalProperties":false,"required":["kind","layoutRef","pagination"],"properties":{"kind":{"const":"flow-page"},"layoutRef":{"$ref":"#/$defs/Reference"},"layoutSha256":{"$ref":"#/$defs/Sha256"},"pagination":{"const":"flow"}}};

function validate46(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate46.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.kind === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.layoutRef === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "layoutRef"},message:"must have required property '"+"layoutRef"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.pagination === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "pagination"},message:"must have required property '"+"pagination"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "kind") || (key0 === "layoutRef")) || (key0 === "layoutSha256")) || (key0 === "pagination"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.kind !== undefined){
if("flow-page" !== data.kind){
const err4 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/const",keyword:"const",params:{allowedValue: "flow-page"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.layoutRef !== undefined){
let data1 = data.layoutRef;
if(typeof data1 === "string"){
if(func2(data1) < 1){
const err5 = {instancePath:instancePath+"/layoutRef",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/layoutRef",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.layoutSha256 !== undefined){
let data2 = data.layoutSha256;
if(typeof data2 === "string"){
if(!pattern10.test(data2)){
const err7 = {instancePath:instancePath+"/layoutSha256",schemaPath:"#/$defs/Sha256/pattern",keyword:"pattern",params:{pattern: "^sha256:[a-f0-9]{64}$"},message:"must match pattern \""+"^sha256:[a-f0-9]{64}$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/layoutSha256",schemaPath:"#/$defs/Sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.pagination !== undefined){
if("flow" !== data.pagination){
const err9 = {instancePath:instancePath+"/pagination",schemaPath:"#/properties/pagination/const",keyword:"const",params:{allowedValue: "flow"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
else {
const err10 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
validate46.errors = vErrors;
return errors === 0;
}
validate46.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema80 = {"type":"object","additionalProperties":false,"required":["kind","masterRef","canvas"],"properties":{"kind":{"const":"fixed-page"},"masterRef":{"$ref":"#/$defs/Reference"},"canvas":{"enum":["wide","standard","a4","letter"]}}};

function validate48(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate48.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.kind === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.masterRef === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "masterRef"},message:"must have required property '"+"masterRef"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.canvas === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "canvas"},message:"must have required property '"+"canvas"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "kind") || (key0 === "masterRef")) || (key0 === "canvas"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.kind !== undefined){
if("fixed-page" !== data.kind){
const err4 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/const",keyword:"const",params:{allowedValue: "fixed-page"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.masterRef !== undefined){
let data1 = data.masterRef;
if(typeof data1 === "string"){
if(func2(data1) < 1){
const err5 = {instancePath:instancePath+"/masterRef",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/masterRef",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.canvas !== undefined){
let data2 = data.canvas;
if(!((((data2 === "wide") || (data2 === "standard")) || (data2 === "a4")) || (data2 === "letter"))){
const err7 = {instancePath:instancePath+"/canvas",schemaPath:"#/properties/canvas/enum",keyword:"enum",params:{allowedValues: schema80.properties.canvas.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
validate48.errors = vErrors;
return errors === 0;
}
validate48.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema82 = {"type":"object","additionalProperties":false,"required":["kind","workbookSidecarRef"],"properties":{"kind":{"const":"workbook"},"workbookSidecarRef":{"$ref":"#/$defs/Reference"}}};

function validate50(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate50.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.kind === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.workbookSidecarRef === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "workbookSidecarRef"},message:"must have required property '"+"workbookSidecarRef"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "kind") || (key0 === "workbookSidecarRef"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.kind !== undefined){
if("workbook" !== data.kind){
const err3 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/const",keyword:"const",params:{allowedValue: "workbook"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.workbookSidecarRef !== undefined){
let data1 = data.workbookSidecarRef;
if(typeof data1 === "string"){
if(func2(data1) < 1){
const err4 = {instancePath:instancePath+"/workbookSidecarRef",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/workbookSidecarRef",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
else {
const err6 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
validate50.errors = vErrors;
return errors === 0;
}
validate50.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema84 = {"type":"object","additionalProperties":false,"required":["kind","blockSchemaRef"],"properties":{"kind":{"const":"block-page"},"blockSchemaRef":{"$ref":"#/$defs/Reference"}}};

function validate52(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate52.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.kind === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.blockSchemaRef === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "blockSchemaRef"},message:"must have required property '"+"blockSchemaRef"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "kind") || (key0 === "blockSchemaRef"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.kind !== undefined){
if("block-page" !== data.kind){
const err3 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/const",keyword:"const",params:{allowedValue: "block-page"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.blockSchemaRef !== undefined){
let data1 = data.blockSchemaRef;
if(typeof data1 === "string"){
if(func2(data1) < 1){
const err4 = {instancePath:instancePath+"/blockSchemaRef",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/blockSchemaRef",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
else {
const err6 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
validate52.errors = vErrors;
return errors === 0;
}
validate52.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema102 = {"type":"object","additionalProperties":false,"required":["slotId","bindingRef"],"properties":{"slotId":{"$ref":"#/$defs/KebabId"},"bindingRef":{"$ref":"#/$defs/Reference"}}};

function validate58(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate58.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.slotId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "slotId"},message:"must have required property '"+"slotId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.bindingRef === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "bindingRef"},message:"must have required property '"+"bindingRef"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "slotId") || (key0 === "bindingRef"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.slotId !== undefined){
let data0 = data.slotId;
if(typeof data0 === "string"){
if(!pattern4.test(data0)){
const err3 = {instancePath:instancePath+"/slotId",schemaPath:"#/$defs/KebabId/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9]+(?:-[a-z0-9]+)*$"},message:"must match pattern \""+"^[a-z0-9]+(?:-[a-z0-9]+)*$"+"\""};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
else {
const err4 = {instancePath:instancePath+"/slotId",schemaPath:"#/$defs/KebabId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.bindingRef !== undefined){
let data1 = data.bindingRef;
if(typeof data1 === "string"){
if(func2(data1) < 1){
const err5 = {instancePath:instancePath+"/bindingRef",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/bindingRef",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
}
else {
const err7 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
validate58.errors = vErrors;
return errors === 0;
}
validate58.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema105 = {"type":"object","additionalProperties":false,"required":["slotId","reason","approvedByRef","evidenceRef"],"properties":{"slotId":{"$ref":"#/$defs/KebabId"},"reason":{"type":"string","minLength":1},"approvedByRef":{"$ref":"#/$defs/Reference"},"evidenceRef":{"$ref":"#/$defs/Reference"}}};

function validate60(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate60.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.slotId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "slotId"},message:"must have required property '"+"slotId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.reason === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "reason"},message:"must have required property '"+"reason"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.approvedByRef === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "approvedByRef"},message:"must have required property '"+"approvedByRef"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.evidenceRef === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "evidenceRef"},message:"must have required property '"+"evidenceRef"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "slotId") || (key0 === "reason")) || (key0 === "approvedByRef")) || (key0 === "evidenceRef"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.slotId !== undefined){
let data0 = data.slotId;
if(typeof data0 === "string"){
if(!pattern4.test(data0)){
const err5 = {instancePath:instancePath+"/slotId",schemaPath:"#/$defs/KebabId/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9]+(?:-[a-z0-9]+)*$"},message:"must match pattern \""+"^[a-z0-9]+(?:-[a-z0-9]+)*$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/slotId",schemaPath:"#/$defs/KebabId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.reason !== undefined){
let data1 = data.reason;
if(typeof data1 === "string"){
if(func2(data1) < 1){
const err7 = {instancePath:instancePath+"/reason",schemaPath:"#/properties/reason/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/reason",schemaPath:"#/properties/reason/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.approvedByRef !== undefined){
let data2 = data.approvedByRef;
if(typeof data2 === "string"){
if(func2(data2) < 1){
const err9 = {instancePath:instancePath+"/approvedByRef",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/approvedByRef",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.evidenceRef !== undefined){
let data3 = data.evidenceRef;
if(typeof data3 === "string"){
if(func2(data3) < 1){
const err11 = {instancePath:instancePath+"/evidenceRef",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/evidenceRef",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
}
else {
const err13 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
validate60.errors = vErrors;
return errors === 0;
}
validate60.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema109 = {"oneOf":[{"$ref":"#/$defs/DocxOverlay"},{"$ref":"#/$defs/HwpxOverlay"},{"$ref":"#/$defs/PptxOverlay"},{"$ref":"#/$defs/XlsxOverlay"},{"$ref":"#/$defs/PdfOverlay"},{"$ref":"#/$defs/GoogleDocsOverlay"},{"$ref":"#/$defs/NotionCogoBlockTemplateOverlay"},{"$ref":"#/$defs/NotionDataSourceTemplateOverlay"}]};
const schema110 = {"allOf":[{"$ref":"#/$defs/TargetOverlayBase"},{"type":"object","required":["templateMode"],"properties":{"target":{"const":"docx"},"templateMode":{"enum":["generated-from-cogo","optional-native-template"]}}}],"unevaluatedProperties":false};
const schema111 = {"type":"object","required":["target","adapter","canonicalAuthority","implementationStatus","readbackRequired"],"properties":{"target":{"enum":["docx","hwpx","pptx","xlsx","pdf","google-docs","notion"]},"adapter":{"$ref":"#/$defs/Reference"},"canonicalAuthority":{"const":false},"implementationStatus":{"enum":["production-ready","partial","planned"]},"readbackRequired":{"const":true}}};

function validate64(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate64.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.target === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.adapter === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "adapter"},message:"must have required property '"+"adapter"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.canonicalAuthority === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "canonicalAuthority"},message:"must have required property '"+"canonicalAuthority"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.implementationStatus === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "implementationStatus"},message:"must have required property '"+"implementationStatus"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.readbackRequired === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "readbackRequired"},message:"must have required property '"+"readbackRequired"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.target !== undefined){
let data0 = data.target;
if(!(((((((data0 === "docx") || (data0 === "hwpx")) || (data0 === "pptx")) || (data0 === "xlsx")) || (data0 === "pdf")) || (data0 === "google-docs")) || (data0 === "notion"))){
const err5 = {instancePath:instancePath+"/target",schemaPath:"#/properties/target/enum",keyword:"enum",params:{allowedValues: schema111.properties.target.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.adapter !== undefined){
let data1 = data.adapter;
if(typeof data1 === "string"){
if(func2(data1) < 1){
const err6 = {instancePath:instancePath+"/adapter",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/adapter",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.canonicalAuthority !== undefined){
if(false !== data.canonicalAuthority){
const err8 = {instancePath:instancePath+"/canonicalAuthority",schemaPath:"#/properties/canonicalAuthority/const",keyword:"const",params:{allowedValue: false},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.implementationStatus !== undefined){
let data3 = data.implementationStatus;
if(!(((data3 === "production-ready") || (data3 === "partial")) || (data3 === "planned"))){
const err9 = {instancePath:instancePath+"/implementationStatus",schemaPath:"#/properties/implementationStatus/enum",keyword:"enum",params:{allowedValues: schema111.properties.implementationStatus.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.readbackRequired !== undefined){
if(true !== data.readbackRequired){
const err10 = {instancePath:instancePath+"/readbackRequired",schemaPath:"#/properties/readbackRequired/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
else {
const err11 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
validate64.errors = vErrors;
return errors === 0;
}
validate64.evaluated = {"props":{"target":true,"adapter":true,"canonicalAuthority":true,"implementationStatus":true,"readbackRequired":true},"dynamicProps":false,"dynamicItems":false};


function validate63(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate63.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate64(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate64.errors : vErrors.concat(validate64.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.templateMode === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "templateMode"},message:"must have required property '"+"templateMode"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.target !== undefined){
if("docx" !== data.target){
const err1 = {instancePath:instancePath+"/target",schemaPath:"#/allOf/1/properties/target/const",keyword:"const",params:{allowedValue: "docx"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.templateMode !== undefined){
let data1 = data.templateMode;
if(!((data1 === "generated-from-cogo") || (data1 === "optional-native-template"))){
const err2 = {instancePath:instancePath+"/templateMode",schemaPath:"#/allOf/1/properties/templateMode/enum",keyword:"enum",params:{allowedValues: schema110.allOf[1].properties.templateMode.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
}
else {
const err3 = {instancePath,schemaPath:"#/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
if((((((key0 !== "target") && (key0 !== "templateMode")) && (key0 !== "adapter")) && (key0 !== "canonicalAuthority")) && (key0 !== "implementationStatus")) && (key0 !== "readbackRequired")){
const err4 = {instancePath,schemaPath:"#/unevaluatedProperties",keyword:"unevaluatedProperties",params:{unevaluatedProperty: key0},message:"must NOT have unevaluated properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
}
validate63.errors = vErrors;
return errors === 0;
}
validate63.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema113 = {"allOf":[{"$ref":"#/$defs/TargetOverlayBase"},{"type":"object","required":["templateMode"],"properties":{"target":{"const":"hwpx"},"templateMode":{"enum":["generated-from-cogo","optional-native-template"]}}}],"unevaluatedProperties":false};

function validate67(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate67.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate64(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate64.errors : vErrors.concat(validate64.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.templateMode === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "templateMode"},message:"must have required property '"+"templateMode"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.target !== undefined){
if("hwpx" !== data.target){
const err1 = {instancePath:instancePath+"/target",schemaPath:"#/allOf/1/properties/target/const",keyword:"const",params:{allowedValue: "hwpx"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.templateMode !== undefined){
let data1 = data.templateMode;
if(!((data1 === "generated-from-cogo") || (data1 === "optional-native-template"))){
const err2 = {instancePath:instancePath+"/templateMode",schemaPath:"#/allOf/1/properties/templateMode/enum",keyword:"enum",params:{allowedValues: schema113.allOf[1].properties.templateMode.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
}
else {
const err3 = {instancePath,schemaPath:"#/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
if((((((key0 !== "target") && (key0 !== "templateMode")) && (key0 !== "adapter")) && (key0 !== "canonicalAuthority")) && (key0 !== "implementationStatus")) && (key0 !== "readbackRequired")){
const err4 = {instancePath,schemaPath:"#/unevaluatedProperties",keyword:"unevaluatedProperties",params:{unevaluatedProperty: key0},message:"must NOT have unevaluated properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
}
validate67.errors = vErrors;
return errors === 0;
}
validate67.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema114 = {"allOf":[{"$ref":"#/$defs/TargetOverlayBase"},{"type":"object","required":["capabilityMode","motionOverlayStatus"],"properties":{"target":{"const":"pptx"},"capabilityMode":{"const":"static-only"},"motionOverlayStatus":{"const":"not-implemented"},"sourceTemplateRef":{"$ref":"#/$defs/Reference"}}}],"unevaluatedProperties":false};

function validate70(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate70.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate64(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate64.errors : vErrors.concat(validate64.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.capabilityMode === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "capabilityMode"},message:"must have required property '"+"capabilityMode"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.motionOverlayStatus === undefined){
const err1 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "motionOverlayStatus"},message:"must have required property '"+"motionOverlayStatus"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.target !== undefined){
if("pptx" !== data.target){
const err2 = {instancePath:instancePath+"/target",schemaPath:"#/allOf/1/properties/target/const",keyword:"const",params:{allowedValue: "pptx"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.capabilityMode !== undefined){
if("static-only" !== data.capabilityMode){
const err3 = {instancePath:instancePath+"/capabilityMode",schemaPath:"#/allOf/1/properties/capabilityMode/const",keyword:"const",params:{allowedValue: "static-only"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.motionOverlayStatus !== undefined){
if("not-implemented" !== data.motionOverlayStatus){
const err4 = {instancePath:instancePath+"/motionOverlayStatus",schemaPath:"#/allOf/1/properties/motionOverlayStatus/const",keyword:"const",params:{allowedValue: "not-implemented"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.sourceTemplateRef !== undefined){
let data3 = data.sourceTemplateRef;
if(typeof data3 === "string"){
if(func2(data3) < 1){
const err5 = {instancePath:instancePath+"/sourceTemplateRef",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/sourceTemplateRef",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
}
else {
const err7 = {instancePath,schemaPath:"#/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
if((((((((key0 !== "target") && (key0 !== "capabilityMode")) && (key0 !== "motionOverlayStatus")) && (key0 !== "sourceTemplateRef")) && (key0 !== "adapter")) && (key0 !== "canonicalAuthority")) && (key0 !== "implementationStatus")) && (key0 !== "readbackRequired")){
const err8 = {instancePath,schemaPath:"#/unevaluatedProperties",keyword:"unevaluatedProperties",params:{unevaluatedProperty: key0},message:"must NOT have unevaluated properties"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
validate70.errors = vErrors;
return errors === 0;
}
validate70.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema116 = {"allOf":[{"$ref":"#/$defs/TargetOverlayBase"},{"type":"object","required":["sourceTemplateRequired","sourceTemplateRef","workbookSidecarRef"],"properties":{"target":{"const":"xlsx"},"sourceTemplateRequired":{"const":true},"sourceTemplateRef":{"$ref":"#/$defs/Reference"},"workbookSidecarRef":{"$ref":"#/$defs/Reference"}}}],"unevaluatedProperties":false};

function validate73(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate73.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate64(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate64.errors : vErrors.concat(validate64.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.sourceTemplateRequired === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "sourceTemplateRequired"},message:"must have required property '"+"sourceTemplateRequired"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.sourceTemplateRef === undefined){
const err1 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "sourceTemplateRef"},message:"must have required property '"+"sourceTemplateRef"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.workbookSidecarRef === undefined){
const err2 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "workbookSidecarRef"},message:"must have required property '"+"workbookSidecarRef"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.target !== undefined){
if("xlsx" !== data.target){
const err3 = {instancePath:instancePath+"/target",schemaPath:"#/allOf/1/properties/target/const",keyword:"const",params:{allowedValue: "xlsx"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.sourceTemplateRequired !== undefined){
if(true !== data.sourceTemplateRequired){
const err4 = {instancePath:instancePath+"/sourceTemplateRequired",schemaPath:"#/allOf/1/properties/sourceTemplateRequired/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.sourceTemplateRef !== undefined){
let data2 = data.sourceTemplateRef;
if(typeof data2 === "string"){
if(func2(data2) < 1){
const err5 = {instancePath:instancePath+"/sourceTemplateRef",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/sourceTemplateRef",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.workbookSidecarRef !== undefined){
let data3 = data.workbookSidecarRef;
if(typeof data3 === "string"){
if(func2(data3) < 1){
const err7 = {instancePath:instancePath+"/workbookSidecarRef",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/workbookSidecarRef",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
if((((((((key0 !== "target") && (key0 !== "sourceTemplateRequired")) && (key0 !== "sourceTemplateRef")) && (key0 !== "workbookSidecarRef")) && (key0 !== "adapter")) && (key0 !== "canonicalAuthority")) && (key0 !== "implementationStatus")) && (key0 !== "readbackRequired")){
const err10 = {instancePath,schemaPath:"#/unevaluatedProperties",keyword:"unevaluatedProperties",params:{unevaluatedProperty: key0},message:"must NOT have unevaluated properties"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
validate73.errors = vErrors;
return errors === 0;
}
validate73.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema119 = {"allOf":[{"$ref":"#/$defs/TargetOverlayBase"},{"type":"object","required":["outputOnly","editable"],"properties":{"target":{"const":"pdf"},"outputOnly":{"const":true},"editable":{"const":false}}}],"unevaluatedProperties":false};

function validate76(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate76.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate64(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate64.errors : vErrors.concat(validate64.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.outputOnly === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "outputOnly"},message:"must have required property '"+"outputOnly"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.editable === undefined){
const err1 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "editable"},message:"must have required property '"+"editable"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.target !== undefined){
if("pdf" !== data.target){
const err2 = {instancePath:instancePath+"/target",schemaPath:"#/allOf/1/properties/target/const",keyword:"const",params:{allowedValue: "pdf"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.outputOnly !== undefined){
if(true !== data.outputOnly){
const err3 = {instancePath:instancePath+"/outputOnly",schemaPath:"#/allOf/1/properties/outputOnly/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.editable !== undefined){
if(false !== data.editable){
const err4 = {instancePath:instancePath+"/editable",schemaPath:"#/allOf/1/properties/editable/const",keyword:"const",params:{allowedValue: false},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
}
else {
const err5 = {instancePath,schemaPath:"#/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
if(((((((key0 !== "target") && (key0 !== "outputOnly")) && (key0 !== "editable")) && (key0 !== "adapter")) && (key0 !== "canonicalAuthority")) && (key0 !== "implementationStatus")) && (key0 !== "readbackRequired")){
const err6 = {instancePath,schemaPath:"#/unevaluatedProperties",keyword:"unevaluatedProperties",params:{unevaluatedProperty: key0},message:"must NOT have unevaluated properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
}
validate76.errors = vErrors;
return errors === 0;
}
validate76.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema120 = {"allOf":[{"$ref":"#/$defs/TargetOverlayBase"},{"type":"object","required":["templateMode","sourceTemplateRef","copyBeforeMutation"],"properties":{"target":{"const":"google-docs"},"templateMode":{"const":"native-copy"},"sourceTemplateRef":{"$ref":"#/$defs/Reference"},"copyBeforeMutation":{"const":true}}}],"unevaluatedProperties":false};

function validate79(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate79.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate64(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate64.errors : vErrors.concat(validate64.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.templateMode === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "templateMode"},message:"must have required property '"+"templateMode"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.sourceTemplateRef === undefined){
const err1 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "sourceTemplateRef"},message:"must have required property '"+"sourceTemplateRef"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.copyBeforeMutation === undefined){
const err2 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "copyBeforeMutation"},message:"must have required property '"+"copyBeforeMutation"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.target !== undefined){
if("google-docs" !== data.target){
const err3 = {instancePath:instancePath+"/target",schemaPath:"#/allOf/1/properties/target/const",keyword:"const",params:{allowedValue: "google-docs"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.templateMode !== undefined){
if("native-copy" !== data.templateMode){
const err4 = {instancePath:instancePath+"/templateMode",schemaPath:"#/allOf/1/properties/templateMode/const",keyword:"const",params:{allowedValue: "native-copy"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.sourceTemplateRef !== undefined){
let data2 = data.sourceTemplateRef;
if(typeof data2 === "string"){
if(func2(data2) < 1){
const err5 = {instancePath:instancePath+"/sourceTemplateRef",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/sourceTemplateRef",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.copyBeforeMutation !== undefined){
if(true !== data.copyBeforeMutation){
const err7 = {instancePath:instancePath+"/copyBeforeMutation",schemaPath:"#/allOf/1/properties/copyBeforeMutation/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
if((((((((key0 !== "target") && (key0 !== "templateMode")) && (key0 !== "sourceTemplateRef")) && (key0 !== "copyBeforeMutation")) && (key0 !== "adapter")) && (key0 !== "canonicalAuthority")) && (key0 !== "implementationStatus")) && (key0 !== "readbackRequired")){
const err9 = {instancePath,schemaPath:"#/unevaluatedProperties",keyword:"unevaluatedProperties",params:{unevaluatedProperty: key0},message:"must NOT have unevaluated properties"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
validate79.errors = vErrors;
return errors === 0;
}
validate79.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema122 = {"allOf":[{"$ref":"#/$defs/TargetOverlayBase"},{"type":"object","required":["templateMode","blockTemplateRef","asyncTemplateReadbackRequired"],"properties":{"target":{"const":"notion"},"templateMode":{"const":"cogo-block-template"},"blockTemplateRef":{"$ref":"#/$defs/Reference"},"asyncTemplateReadbackRequired":{"const":false}}}],"unevaluatedProperties":false};

function validate82(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate82.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate64(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate64.errors : vErrors.concat(validate64.errors);
errors = vErrors.length;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.templateMode === undefined){
const err0 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "templateMode"},message:"must have required property '"+"templateMode"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.blockTemplateRef === undefined){
const err1 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "blockTemplateRef"},message:"must have required property '"+"blockTemplateRef"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.asyncTemplateReadbackRequired === undefined){
const err2 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "asyncTemplateReadbackRequired"},message:"must have required property '"+"asyncTemplateReadbackRequired"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.target !== undefined){
if("notion" !== data.target){
const err3 = {instancePath:instancePath+"/target",schemaPath:"#/allOf/1/properties/target/const",keyword:"const",params:{allowedValue: "notion"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.templateMode !== undefined){
if("cogo-block-template" !== data.templateMode){
const err4 = {instancePath:instancePath+"/templateMode",schemaPath:"#/allOf/1/properties/templateMode/const",keyword:"const",params:{allowedValue: "cogo-block-template"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.blockTemplateRef !== undefined){
let data2 = data.blockTemplateRef;
if(typeof data2 === "string"){
if(func2(data2) < 1){
const err5 = {instancePath:instancePath+"/blockTemplateRef",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/blockTemplateRef",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.asyncTemplateReadbackRequired !== undefined){
if(false !== data.asyncTemplateReadbackRequired){
const err7 = {instancePath:instancePath+"/asyncTemplateReadbackRequired",schemaPath:"#/allOf/1/properties/asyncTemplateReadbackRequired/const",keyword:"const",params:{allowedValue: false},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
if((((((((key0 !== "target") && (key0 !== "templateMode")) && (key0 !== "blockTemplateRef")) && (key0 !== "asyncTemplateReadbackRequired")) && (key0 !== "adapter")) && (key0 !== "canonicalAuthority")) && (key0 !== "implementationStatus")) && (key0 !== "readbackRequired")){
const err9 = {instancePath,schemaPath:"#/unevaluatedProperties",keyword:"unevaluatedProperties",params:{unevaluatedProperty: key0},message:"must NOT have unevaluated properties"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
validate82.errors = vErrors;
return errors === 0;
}
validate82.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema124 = {"allOf":[{"$ref":"#/$defs/TargetOverlayBase"},{"type":"object","required":["templateMode","templateSelection","asyncTemplateReadbackRequired"],"properties":{"target":{"const":"notion"},"templateMode":{"const":"data-source-template"},"templateSelection":{"enum":["explicit-template","default-template"]},"templateRef":{"$ref":"#/$defs/Reference"},"asyncTemplateReadbackRequired":{"const":true}},"allOf":[{"if":{"properties":{"templateSelection":{"const":"explicit-template"}},"required":["templateSelection"]},"then":{"required":["templateRef"]},"else":{"not":{"required":["templateRef"]}}}]}],"unevaluatedProperties":false};

function validate85(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate85.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate64(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate64.errors : vErrors.concat(validate64.errors);
errors = vErrors.length;
}
const _errs4 = errors;
let valid2 = true;
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing0;
if((data.templateSelection === undefined) && (missing0 = "templateSelection")){
const err0 = {};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
if(data.templateSelection !== undefined){
if("explicit-template" !== data.templateSelection){
const err1 = {};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
}
}
var _valid0 = _errs5 === errors;
errors = _errs4;
if(vErrors !== null){
if(_errs4){
vErrors.length = _errs4;
}
else {
vErrors = null;
}
}
let ifClause0;
if(_valid0){
const _errs7 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.templateRef === undefined){
const err2 = {instancePath,schemaPath:"#/allOf/1/allOf/0/then/required",keyword:"required",params:{missingProperty: "templateRef"},message:"must have required property '"+"templateRef"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
var _valid0 = _errs7 === errors;
valid2 = _valid0;
ifClause0 = "then";
}
else {
const _errs8 = errors;
const _errs9 = errors;
const _errs10 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing1;
if((data.templateRef === undefined) && (missing1 = "templateRef")){
const err3 = {};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
var valid4 = _errs10 === errors;
if(valid4){
const err4 = {instancePath,schemaPath:"#/allOf/1/allOf/0/else/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
else {
errors = _errs9;
if(vErrors !== null){
if(_errs9){
vErrors.length = _errs9;
}
else {
vErrors = null;
}
}
}
var _valid0 = _errs8 === errors;
valid2 = _valid0;
ifClause0 = "else";
}
if(!valid2){
const err5 = {instancePath,schemaPath:"#/allOf/1/allOf/0/if",keyword:"if",params:{failingKeyword: ifClause0},message:"must match \""+ifClause0+"\" schema"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.templateMode === undefined){
const err6 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "templateMode"},message:"must have required property '"+"templateMode"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.templateSelection === undefined){
const err7 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "templateSelection"},message:"must have required property '"+"templateSelection"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.asyncTemplateReadbackRequired === undefined){
const err8 = {instancePath,schemaPath:"#/allOf/1/required",keyword:"required",params:{missingProperty: "asyncTemplateReadbackRequired"},message:"must have required property '"+"asyncTemplateReadbackRequired"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.target !== undefined){
if("notion" !== data.target){
const err9 = {instancePath:instancePath+"/target",schemaPath:"#/allOf/1/properties/target/const",keyword:"const",params:{allowedValue: "notion"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.templateMode !== undefined){
if("data-source-template" !== data.templateMode){
const err10 = {instancePath:instancePath+"/templateMode",schemaPath:"#/allOf/1/properties/templateMode/const",keyword:"const",params:{allowedValue: "data-source-template"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.templateSelection !== undefined){
let data3 = data.templateSelection;
if(!((data3 === "explicit-template") || (data3 === "default-template"))){
const err11 = {instancePath:instancePath+"/templateSelection",schemaPath:"#/allOf/1/properties/templateSelection/enum",keyword:"enum",params:{allowedValues: schema124.allOf[1].properties.templateSelection.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.templateRef !== undefined){
let data4 = data.templateRef;
if(typeof data4 === "string"){
if(func2(data4) < 1){
const err12 = {instancePath:instancePath+"/templateRef",schemaPath:"#/$defs/Reference/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/templateRef",schemaPath:"#/$defs/Reference/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.asyncTemplateReadbackRequired !== undefined){
if(true !== data.asyncTemplateReadbackRequired){
const err14 = {instancePath:instancePath+"/asyncTemplateReadbackRequired",schemaPath:"#/allOf/1/properties/asyncTemplateReadbackRequired/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
else {
const err15 = {instancePath,schemaPath:"#/allOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
if(((((((((key0 !== "target") && (key0 !== "templateMode")) && (key0 !== "templateSelection")) && (key0 !== "templateRef")) && (key0 !== "asyncTemplateReadbackRequired")) && (key0 !== "adapter")) && (key0 !== "canonicalAuthority")) && (key0 !== "implementationStatus")) && (key0 !== "readbackRequired")){
const err16 = {instancePath,schemaPath:"#/unevaluatedProperties",keyword:"unevaluatedProperties",params:{unevaluatedProperty: key0},message:"must NOT have unevaluated properties"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
validate85.errors = vErrors;
return errors === 0;
}
validate85.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate62(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate62.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(!(validate63(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
errors = vErrors.length;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs2 = errors;
if(!(validate67(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate67.errors : vErrors.concat(validate67.errors);
errors = vErrors.length;
}
var _valid0 = _errs2 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
const _errs3 = errors;
if(!(validate70(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate70.errors : vErrors.concat(validate70.errors);
errors = vErrors.length;
}
var _valid0 = _errs3 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 2];
}
else {
if(_valid0){
valid0 = true;
passing0 = 2;
if(props0 !== true){
props0 = true;
}
}
const _errs4 = errors;
if(!(validate73(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate73.errors : vErrors.concat(validate73.errors);
errors = vErrors.length;
}
var _valid0 = _errs4 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 3];
}
else {
if(_valid0){
valid0 = true;
passing0 = 3;
if(props0 !== true){
props0 = true;
}
}
const _errs5 = errors;
if(!(validate76(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate76.errors : vErrors.concat(validate76.errors);
errors = vErrors.length;
}
var _valid0 = _errs5 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 4];
}
else {
if(_valid0){
valid0 = true;
passing0 = 4;
if(props0 !== true){
props0 = true;
}
}
const _errs6 = errors;
if(!(validate79(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate79.errors : vErrors.concat(validate79.errors);
errors = vErrors.length;
}
var _valid0 = _errs6 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 5];
}
else {
if(_valid0){
valid0 = true;
passing0 = 5;
if(props0 !== true){
props0 = true;
}
}
const _errs7 = errors;
if(!(validate82(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate82.errors : vErrors.concat(validate82.errors);
errors = vErrors.length;
}
var _valid0 = _errs7 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 6];
}
else {
if(_valid0){
valid0 = true;
passing0 = 6;
if(props0 !== true){
props0 = true;
}
}
const _errs8 = errors;
if(!(validate85(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate85.errors : vErrors.concat(validate85.errors);
errors = vErrors.length;
}
var _valid0 = _errs8 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 7];
}
else {
if(_valid0){
valid0 = true;
passing0 = 7;
if(props0 !== true){
props0 = true;
}
}
}
}
}
}
}
}
}
if(!valid0){
const err0 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate62.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate62.evaluated = {"dynamicProps":true,"dynamicItems":false};


function validate45(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate45.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs2 = errors;
let valid1 = false;
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.renderTargets !== undefined){
let data0 = data.renderTargets;
if(Array.isArray(data0)){
if(data0.length < 1){
const err0 = {instancePath:instancePath+"/renderTargets",schemaPath:"#/allOf/0/anyOf/0/properties/renderTargets/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
}
var _valid0 = _errs3 === errors;
valid1 = valid1 || _valid0;
if(_valid0){
var props0 = {};
props0.renderTargets = true;
}
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.publicationTargets !== undefined){
let data1 = data.publicationTargets;
if(Array.isArray(data1)){
if(data1.length < 1){
const err1 = {instancePath:instancePath+"/publicationTargets",schemaPath:"#/allOf/0/anyOf/1/properties/publicationTargets/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
}
}
var _valid0 = _errs5 === errors;
valid1 = valid1 || _valid0;
if(_valid0){
if(props0 !== true){
props0 = props0 || {};
props0.publicationTargets = true;
}
}
if(!valid1){
const err2 = {instancePath,schemaPath:"#/allOf/0/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
else {
errors = _errs2;
if(vErrors !== null){
if(_errs2){
vErrors.length = _errs2;
}
else {
vErrors = null;
}
}
}
const _errs8 = errors;
let valid4 = true;
const _errs9 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing0;
if((data.capabilityStatus === undefined) && (missing0 = "capabilityStatus")){
const err3 = {};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
else {
if(data.capabilityStatus !== undefined){
if("production-ready" !== data.capabilityStatus){
const err4 = {};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
}
}
var _valid1 = _errs9 === errors;
errors = _errs8;
if(vErrors !== null){
if(_errs8){
vErrors.length = _errs8;
}
else {
vErrors = null;
}
}
if(_valid1){
const _errs11 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.targetOverlays !== undefined){
let data3 = data.targetOverlays;
if(Array.isArray(data3)){
const len0 = data3.length;
for(let i0=0; i0<len0; i0++){
let data4 = data3[i0];
if(data4 && typeof data4 == "object" && !Array.isArray(data4)){
if(data4.implementationStatus === undefined){
const err5 = {instancePath:instancePath+"/targetOverlays/" + i0,schemaPath:"#/allOf/1/then/properties/targetOverlays/items/required",keyword:"required",params:{missingProperty: "implementationStatus"},message:"must have required property '"+"implementationStatus"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data4.implementationStatus !== undefined){
if("production-ready" !== data4.implementationStatus){
const err6 = {instancePath:instancePath+"/targetOverlays/" + i0+"/implementationStatus",schemaPath:"#/allOf/1/then/properties/targetOverlays/items/properties/implementationStatus/const",keyword:"const",params:{allowedValue: "production-ready"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
}
else {
const err7 = {instancePath:instancePath+"/targetOverlays/" + i0,schemaPath:"#/allOf/1/then/properties/targetOverlays/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
}
}
var _valid1 = _errs11 === errors;
valid4 = _valid1;
if(valid4){
var props1 = {};
props1.targetOverlays = true;
props1.capabilityStatus = true;
}
}
if(!valid4){
const err8 = {instancePath,schemaPath:"#/allOf/1/if",keyword:"if",params:{failingKeyword: "then"},message:"must match \"then\" schema"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(props0 !== true && props1 !== undefined){
if(props1 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props1);
}
}
const _errs17 = errors;
let valid10 = true;
const _errs18 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing1;
if((data.layoutProfile === undefined) && (missing1 = "layoutProfile")){
const err9 = {};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
else {
if(data.layoutProfile !== undefined){
if("flow-page" !== data.layoutProfile){
const err10 = {};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
}
var _valid2 = _errs18 === errors;
errors = _errs17;
if(vErrors !== null){
if(_errs17){
vErrors.length = _errs17;
}
else {
vErrors = null;
}
}
if(_valid2){
const _errs20 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.layout !== undefined){
if(!(validate46(data.layout, {instancePath:instancePath+"/layout",parentData:data,parentDataProperty:"layout",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate46.errors : vErrors.concat(validate46.errors);
errors = vErrors.length;
}
}
if(data.renderTargets !== undefined){
let data8 = data.renderTargets;
if(Array.isArray(data8)){
const len1 = data8.length;
for(let i1=0; i1<len1; i1++){
let data9 = data8[i1];
if(!(((data9 === "docx") || (data9 === "hwpx")) || (data9 === "pdf"))){
const err11 = {instancePath:instancePath+"/renderTargets/" + i1,schemaPath:"#/allOf/2/then/properties/renderTargets/items/enum",keyword:"enum",params:{allowedValues: schema76.allOf[2].then.properties.renderTargets.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
}
if(data.publicationTargets !== undefined){
let data10 = data.publicationTargets;
if(Array.isArray(data10)){
const len2 = data10.length;
for(let i2=0; i2<len2; i2++){
if("google-docs" !== data10[i2]){
const err12 = {instancePath:instancePath+"/publicationTargets/" + i2,schemaPath:"#/allOf/2/then/properties/publicationTargets/items/const",keyword:"const",params:{allowedValue: "google-docs"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
}
}
}
var _valid2 = _errs20 === errors;
valid10 = _valid2;
if(valid10){
var props2 = {};
props2.layout = true;
props2.renderTargets = true;
props2.publicationTargets = true;
props2.layoutProfile = true;
}
}
if(!valid10){
const err13 = {instancePath,schemaPath:"#/allOf/2/if",keyword:"if",params:{failingKeyword: "then"},message:"must match \"then\" schema"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(props0 !== true && props2 !== undefined){
if(props2 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props2);
}
}
const _errs27 = errors;
let valid17 = true;
const _errs28 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing2;
if((data.layoutProfile === undefined) && (missing2 = "layoutProfile")){
const err14 = {};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
else {
if(data.layoutProfile !== undefined){
if("fixed-page" !== data.layoutProfile){
const err15 = {};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
}
var _valid3 = _errs28 === errors;
errors = _errs27;
if(vErrors !== null){
if(_errs27){
vErrors.length = _errs27;
}
else {
vErrors = null;
}
}
if(_valid3){
const _errs30 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.layout !== undefined){
if(!(validate48(data.layout, {instancePath:instancePath+"/layout",parentData:data,parentDataProperty:"layout",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate48.errors : vErrors.concat(validate48.errors);
errors = vErrors.length;
}
}
if(data.renderTargets !== undefined){
let data14 = data.renderTargets;
if(Array.isArray(data14)){
const len3 = data14.length;
for(let i3=0; i3<len3; i3++){
let data15 = data14[i3];
if(!((data15 === "pptx") || (data15 === "pdf"))){
const err16 = {instancePath:instancePath+"/renderTargets/" + i3,schemaPath:"#/allOf/3/then/properties/renderTargets/items/enum",keyword:"enum",params:{allowedValues: schema76.allOf[3].then.properties.renderTargets.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
}
if(data.publicationTargets !== undefined){
let data16 = data.publicationTargets;
if(Array.isArray(data16)){
if(data16.length > 0){
const err17 = {instancePath:instancePath+"/publicationTargets",schemaPath:"#/allOf/3/then/properties/publicationTargets/maxItems",keyword:"maxItems",params:{limit: 0},message:"must NOT have more than 0 items"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
}
}
var _valid3 = _errs30 === errors;
valid17 = _valid3;
if(valid17){
var props3 = {};
props3.layout = true;
props3.renderTargets = true;
props3.publicationTargets = true;
props3.layoutProfile = true;
}
}
if(!valid17){
const err18 = {instancePath,schemaPath:"#/allOf/3/if",keyword:"if",params:{failingKeyword: "then"},message:"must match \"then\" schema"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(props0 !== true && props3 !== undefined){
if(props3 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props3);
}
}
const _errs36 = errors;
let valid22 = true;
const _errs37 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing3;
if((data.layoutProfile === undefined) && (missing3 = "layoutProfile")){
const err19 = {};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
else {
if(data.layoutProfile !== undefined){
if("workbook" !== data.layoutProfile){
const err20 = {};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
}
}
var _valid4 = _errs37 === errors;
errors = _errs36;
if(vErrors !== null){
if(_errs36){
vErrors.length = _errs36;
}
else {
vErrors = null;
}
}
if(_valid4){
const _errs39 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.layout !== undefined){
if(!(validate50(data.layout, {instancePath:instancePath+"/layout",parentData:data,parentDataProperty:"layout",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate50.errors : vErrors.concat(validate50.errors);
errors = vErrors.length;
}
}
if(data.renderTargets !== undefined){
let data19 = data.renderTargets;
if(Array.isArray(data19)){
if(data19.length > 2){
const err21 = {instancePath:instancePath+"/renderTargets",schemaPath:"#/allOf/4/then/properties/renderTargets/maxItems",keyword:"maxItems",params:{limit: 2},message:"must NOT have more than 2 items"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data19.length < 1){
const err22 = {instancePath:instancePath+"/renderTargets",schemaPath:"#/allOf/4/then/properties/renderTargets/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
const len4 = data19.length;
for(let i4=0; i4<len4; i4++){
let data20 = data19[i4];
if(!((data20 === "xlsx") || (data20 === "pdf"))){
const err23 = {instancePath:instancePath+"/renderTargets/" + i4,schemaPath:"#/allOf/4/then/properties/renderTargets/items/enum",keyword:"enum",params:{allowedValues: schema76.allOf[4].then.properties.renderTargets.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
const _errs43 = errors;
const len5 = data19.length;
for(let i5=0; i5<len5; i5++){
const _errs44 = errors;
if("xlsx" !== data19[i5]){
const err24 = {instancePath:instancePath+"/renderTargets/" + i5,schemaPath:"#/allOf/4/then/properties/renderTargets/contains/const",keyword:"const",params:{allowedValue: "xlsx"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
var valid27 = _errs44 === errors;
if(valid27){
break;
}
}
if(!valid27){
const err25 = {instancePath:instancePath+"/renderTargets",schemaPath:"#/allOf/4/then/properties/renderTargets/contains",keyword:"contains",params:{minContains: 1},message:"must contain at least 1 valid item(s)"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
else {
errors = _errs43;
if(vErrors !== null){
if(_errs43){
vErrors.length = _errs43;
}
else {
vErrors = null;
}
}
}
}
}
if(data.publicationTargets !== undefined){
let data22 = data.publicationTargets;
if(Array.isArray(data22)){
if(data22.length > 0){
const err26 = {instancePath:instancePath+"/publicationTargets",schemaPath:"#/allOf/4/then/properties/publicationTargets/maxItems",keyword:"maxItems",params:{limit: 0},message:"must NOT have more than 0 items"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
}
var _valid4 = _errs39 === errors;
valid22 = _valid4;
if(valid22){
var props4 = {};
props4.layout = true;
props4.renderTargets = true;
props4.publicationTargets = true;
props4.layoutProfile = true;
}
}
if(!valid22){
const err27 = {instancePath,schemaPath:"#/allOf/4/if",keyword:"if",params:{failingKeyword: "then"},message:"must match \"then\" schema"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(props0 !== true && props4 !== undefined){
if(props4 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props4);
}
}
const _errs47 = errors;
let valid28 = true;
const _errs48 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing4;
if((data.layoutProfile === undefined) && (missing4 = "layoutProfile")){
const err28 = {};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
else {
if(data.layoutProfile !== undefined){
if("block-page" !== data.layoutProfile){
const err29 = {};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
}
var _valid5 = _errs48 === errors;
errors = _errs47;
if(vErrors !== null){
if(_errs47){
vErrors.length = _errs47;
}
else {
vErrors = null;
}
}
if(_valid5){
const _errs50 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.layout !== undefined){
if(!(validate52(data.layout, {instancePath:instancePath+"/layout",parentData:data,parentDataProperty:"layout",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate52.errors : vErrors.concat(validate52.errors);
errors = vErrors.length;
}
}
if(data.renderTargets !== undefined){
let data25 = data.renderTargets;
if(Array.isArray(data25)){
if(data25.length > 0){
const err30 = {instancePath:instancePath+"/renderTargets",schemaPath:"#/allOf/5/then/properties/renderTargets/maxItems",keyword:"maxItems",params:{limit: 0},message:"must NOT have more than 0 items"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
}
if(data.publicationTargets !== undefined){
let data26 = data.publicationTargets;
if(Array.isArray(data26)){
if(data26.length > 1){
const err31 = {instancePath:instancePath+"/publicationTargets",schemaPath:"#/allOf/5/then/properties/publicationTargets/maxItems",keyword:"maxItems",params:{limit: 1},message:"must NOT have more than 1 items"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data26.length < 1){
const err32 = {instancePath:instancePath+"/publicationTargets",schemaPath:"#/allOf/5/then/properties/publicationTargets/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
const len6 = data26.length;
for(let i6=0; i6<len6; i6++){
if("notion" !== data26[i6]){
const err33 = {instancePath:instancePath+"/publicationTargets/" + i6,schemaPath:"#/allOf/5/then/properties/publicationTargets/items/const",keyword:"const",params:{allowedValue: "notion"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
}
}
}
var _valid5 = _errs50 === errors;
valid28 = _valid5;
if(valid28){
var props5 = {};
props5.layout = true;
props5.renderTargets = true;
props5.publicationTargets = true;
props5.layoutProfile = true;
}
}
if(!valid28){
const err34 = {instancePath,schemaPath:"#/allOf/5/if",keyword:"if",params:{failingKeyword: "then"},message:"must match \"then\" schema"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(props0 !== true && props5 !== undefined){
if(props5 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props5);
}
}
const _errs56 = errors;
let valid33 = true;
const _errs57 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing5;
if((data.renderTargets === undefined) && (missing5 = "renderTargets")){
const err35 = {};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
else {
if(data.renderTargets !== undefined){
let data28 = data.renderTargets;
if(Array.isArray(data28)){
const _errs59 = errors;
const len7 = data28.length;
for(let i7=0; i7<len7; i7++){
const _errs60 = errors;
if("docx" !== data28[i7]){
const err36 = {};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
var valid35 = _errs60 === errors;
if(valid35){
break;
}
}
if(!valid35){
const err37 = {};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
else {
errors = _errs59;
if(vErrors !== null){
if(_errs59){
vErrors.length = _errs59;
}
else {
vErrors = null;
}
}
}
}
}
}
}
var _valid6 = _errs57 === errors;
errors = _errs56;
if(vErrors !== null){
if(_errs56){
vErrors.length = _errs56;
}
else {
vErrors = null;
}
}
let ifClause0;
if(_valid6){
const _errs61 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.targetOverlays !== undefined){
let data30 = data.targetOverlays;
if(Array.isArray(data30)){
const _errs63 = errors;
const len8 = data30.length;
let valid37 = false;
let count0 = 0;
for(let i8=0; i8<len8; i8++){
let data31 = data30[i8];
const _errs64 = errors;
if(data31 && typeof data31 == "object" && !Array.isArray(data31)){
if(data31.target === undefined){
const err38 = {instancePath:instancePath+"/targetOverlays/" + i8,schemaPath:"#/$defs/DocxOverlaySelector/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
if(data31.target !== undefined){
if("docx" !== data31.target){
const err39 = {instancePath:instancePath+"/targetOverlays/" + i8+"/target",schemaPath:"#/$defs/DocxOverlaySelector/properties/target/const",keyword:"const",params:{allowedValue: "docx"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
}
else {
const err40 = {instancePath:instancePath+"/targetOverlays/" + i8,schemaPath:"#/$defs/DocxOverlaySelector/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
var _valid7 = _errs64 === errors;
if(_valid7){
count0++;
if(count0 > 1){
valid37 = false;
break;
}
valid37 = true;
}
}
if(!valid37){
const err41 = {instancePath:instancePath+"/targetOverlays",schemaPath:"#/allOf/6/then/properties/targetOverlays/contains",keyword:"contains",params:{minContains: 1, maxContains: 1},message:"must contain at least 1 and no more than 1 valid item(s)"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
else {
errors = _errs63;
if(vErrors !== null){
if(_errs63){
vErrors.length = _errs63;
}
else {
vErrors = null;
}
}
}
}
}
}
var _valid6 = _errs61 === errors;
valid33 = _valid6;
if(valid33){
var props6 = {};
props6.targetOverlays = true;
props6.renderTargets = true;
}
ifClause0 = "then";
}
else {
const _errs68 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.targetOverlays !== undefined){
let data33 = data.targetOverlays;
const _errs70 = errors;
const _errs71 = errors;
if(Array.isArray(data33)){
const _errs72 = errors;
const len9 = data33.length;
for(let i9=0; i9<len9; i9++){
let data34 = data33[i9];
const _errs73 = errors;
const _errs74 = errors;
if(errors === _errs74){
if(data34 && typeof data34 == "object" && !Array.isArray(data34)){
let missing6;
if((data34.target === undefined) && (missing6 = "target")){
const err42 = {};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
else {
if(data34.target !== undefined){
if("docx" !== data34.target){
const err43 = {};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
}
}
else {
const err44 = {};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
var valid42 = _errs73 === errors;
if(valid42){
break;
}
}
if(!valid42){
const err45 = {};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
else {
errors = _errs72;
if(vErrors !== null){
if(_errs72){
vErrors.length = _errs72;
}
else {
vErrors = null;
}
}
}
}
var valid41 = _errs71 === errors;
if(valid41){
const err46 = {instancePath:instancePath+"/targetOverlays",schemaPath:"#/allOf/6/else/properties/targetOverlays/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
else {
errors = _errs70;
if(vErrors !== null){
if(_errs70){
vErrors.length = _errs70;
}
else {
vErrors = null;
}
}
}
}
}
var _valid6 = _errs68 === errors;
valid33 = _valid6;
if(valid33){
if(props6 !== true){
props6 = props6 || {};
props6.targetOverlays = true;
}
}
ifClause0 = "else";
}
if(!valid33){
const err47 = {instancePath,schemaPath:"#/allOf/6/if",keyword:"if",params:{failingKeyword: ifClause0},message:"must match \""+ifClause0+"\" schema"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
if(props0 !== true && props6 !== undefined){
if(props6 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props6);
}
}
const _errs78 = errors;
let valid45 = true;
const _errs79 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing7;
if((data.renderTargets === undefined) && (missing7 = "renderTargets")){
const err48 = {};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
else {
if(data.renderTargets !== undefined){
let data36 = data.renderTargets;
if(Array.isArray(data36)){
const _errs81 = errors;
const len10 = data36.length;
for(let i10=0; i10<len10; i10++){
const _errs82 = errors;
if("hwpx" !== data36[i10]){
const err49 = {};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
var valid47 = _errs82 === errors;
if(valid47){
break;
}
}
if(!valid47){
const err50 = {};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
else {
errors = _errs81;
if(vErrors !== null){
if(_errs81){
vErrors.length = _errs81;
}
else {
vErrors = null;
}
}
}
}
}
}
}
var _valid8 = _errs79 === errors;
errors = _errs78;
if(vErrors !== null){
if(_errs78){
vErrors.length = _errs78;
}
else {
vErrors = null;
}
}
let ifClause1;
if(_valid8){
const _errs83 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.targetOverlays !== undefined){
let data38 = data.targetOverlays;
if(Array.isArray(data38)){
const _errs85 = errors;
const len11 = data38.length;
let valid49 = false;
let count1 = 0;
for(let i11=0; i11<len11; i11++){
let data39 = data38[i11];
const _errs86 = errors;
if(data39 && typeof data39 == "object" && !Array.isArray(data39)){
if(data39.target === undefined){
const err51 = {instancePath:instancePath+"/targetOverlays/" + i11,schemaPath:"#/$defs/HwpxOverlaySelector/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
if(data39.target !== undefined){
if("hwpx" !== data39.target){
const err52 = {instancePath:instancePath+"/targetOverlays/" + i11+"/target",schemaPath:"#/$defs/HwpxOverlaySelector/properties/target/const",keyword:"const",params:{allowedValue: "hwpx"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
}
}
else {
const err53 = {instancePath:instancePath+"/targetOverlays/" + i11,schemaPath:"#/$defs/HwpxOverlaySelector/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
var _valid9 = _errs86 === errors;
if(_valid9){
count1++;
if(count1 > 1){
valid49 = false;
break;
}
valid49 = true;
}
}
if(!valid49){
const err54 = {instancePath:instancePath+"/targetOverlays",schemaPath:"#/allOf/7/then/properties/targetOverlays/contains",keyword:"contains",params:{minContains: 1, maxContains: 1},message:"must contain at least 1 and no more than 1 valid item(s)"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
else {
errors = _errs85;
if(vErrors !== null){
if(_errs85){
vErrors.length = _errs85;
}
else {
vErrors = null;
}
}
}
}
}
}
var _valid8 = _errs83 === errors;
valid45 = _valid8;
if(valid45){
var props7 = {};
props7.targetOverlays = true;
props7.renderTargets = true;
}
ifClause1 = "then";
}
else {
const _errs90 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.targetOverlays !== undefined){
let data41 = data.targetOverlays;
const _errs92 = errors;
const _errs93 = errors;
if(Array.isArray(data41)){
const _errs94 = errors;
const len12 = data41.length;
for(let i12=0; i12<len12; i12++){
let data42 = data41[i12];
const _errs95 = errors;
const _errs96 = errors;
if(errors === _errs96){
if(data42 && typeof data42 == "object" && !Array.isArray(data42)){
let missing8;
if((data42.target === undefined) && (missing8 = "target")){
const err55 = {};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
else {
if(data42.target !== undefined){
if("hwpx" !== data42.target){
const err56 = {};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
}
}
}
else {
const err57 = {};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
}
var valid54 = _errs95 === errors;
if(valid54){
break;
}
}
if(!valid54){
const err58 = {};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
else {
errors = _errs94;
if(vErrors !== null){
if(_errs94){
vErrors.length = _errs94;
}
else {
vErrors = null;
}
}
}
}
var valid53 = _errs93 === errors;
if(valid53){
const err59 = {instancePath:instancePath+"/targetOverlays",schemaPath:"#/allOf/7/else/properties/targetOverlays/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
else {
errors = _errs92;
if(vErrors !== null){
if(_errs92){
vErrors.length = _errs92;
}
else {
vErrors = null;
}
}
}
}
}
var _valid8 = _errs90 === errors;
valid45 = _valid8;
if(valid45){
if(props7 !== true){
props7 = props7 || {};
props7.targetOverlays = true;
}
}
ifClause1 = "else";
}
if(!valid45){
const err60 = {instancePath,schemaPath:"#/allOf/7/if",keyword:"if",params:{failingKeyword: ifClause1},message:"must match \""+ifClause1+"\" schema"};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
if(props0 !== true && props7 !== undefined){
if(props7 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props7);
}
}
const _errs100 = errors;
let valid57 = true;
const _errs101 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing9;
if((data.renderTargets === undefined) && (missing9 = "renderTargets")){
const err61 = {};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
}
else {
if(data.renderTargets !== undefined){
let data44 = data.renderTargets;
if(Array.isArray(data44)){
const _errs103 = errors;
const len13 = data44.length;
for(let i13=0; i13<len13; i13++){
const _errs104 = errors;
if("pptx" !== data44[i13]){
const err62 = {};
if(vErrors === null){
vErrors = [err62];
}
else {
vErrors.push(err62);
}
errors++;
}
var valid59 = _errs104 === errors;
if(valid59){
break;
}
}
if(!valid59){
const err63 = {};
if(vErrors === null){
vErrors = [err63];
}
else {
vErrors.push(err63);
}
errors++;
}
else {
errors = _errs103;
if(vErrors !== null){
if(_errs103){
vErrors.length = _errs103;
}
else {
vErrors = null;
}
}
}
}
}
}
}
var _valid10 = _errs101 === errors;
errors = _errs100;
if(vErrors !== null){
if(_errs100){
vErrors.length = _errs100;
}
else {
vErrors = null;
}
}
let ifClause2;
if(_valid10){
const _errs105 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.targetOverlays !== undefined){
let data46 = data.targetOverlays;
if(Array.isArray(data46)){
const _errs107 = errors;
const len14 = data46.length;
let valid61 = false;
let count2 = 0;
for(let i14=0; i14<len14; i14++){
let data47 = data46[i14];
const _errs108 = errors;
if(data47 && typeof data47 == "object" && !Array.isArray(data47)){
if(data47.target === undefined){
const err64 = {instancePath:instancePath+"/targetOverlays/" + i14,schemaPath:"#/$defs/PptxOverlaySelector/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err64];
}
else {
vErrors.push(err64);
}
errors++;
}
if(data47.target !== undefined){
if("pptx" !== data47.target){
const err65 = {instancePath:instancePath+"/targetOverlays/" + i14+"/target",schemaPath:"#/$defs/PptxOverlaySelector/properties/target/const",keyword:"const",params:{allowedValue: "pptx"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err65];
}
else {
vErrors.push(err65);
}
errors++;
}
}
}
else {
const err66 = {instancePath:instancePath+"/targetOverlays/" + i14,schemaPath:"#/$defs/PptxOverlaySelector/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err66];
}
else {
vErrors.push(err66);
}
errors++;
}
var _valid11 = _errs108 === errors;
if(_valid11){
count2++;
if(count2 > 1){
valid61 = false;
break;
}
valid61 = true;
}
}
if(!valid61){
const err67 = {instancePath:instancePath+"/targetOverlays",schemaPath:"#/allOf/8/then/properties/targetOverlays/contains",keyword:"contains",params:{minContains: 1, maxContains: 1},message:"must contain at least 1 and no more than 1 valid item(s)"};
if(vErrors === null){
vErrors = [err67];
}
else {
vErrors.push(err67);
}
errors++;
}
else {
errors = _errs107;
if(vErrors !== null){
if(_errs107){
vErrors.length = _errs107;
}
else {
vErrors = null;
}
}
}
}
}
}
var _valid10 = _errs105 === errors;
valid57 = _valid10;
if(valid57){
var props8 = {};
props8.targetOverlays = true;
props8.renderTargets = true;
}
ifClause2 = "then";
}
else {
const _errs112 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.targetOverlays !== undefined){
let data49 = data.targetOverlays;
const _errs114 = errors;
const _errs115 = errors;
if(Array.isArray(data49)){
const _errs116 = errors;
const len15 = data49.length;
for(let i15=0; i15<len15; i15++){
let data50 = data49[i15];
const _errs117 = errors;
const _errs118 = errors;
if(errors === _errs118){
if(data50 && typeof data50 == "object" && !Array.isArray(data50)){
let missing10;
if((data50.target === undefined) && (missing10 = "target")){
const err68 = {};
if(vErrors === null){
vErrors = [err68];
}
else {
vErrors.push(err68);
}
errors++;
}
else {
if(data50.target !== undefined){
if("pptx" !== data50.target){
const err69 = {};
if(vErrors === null){
vErrors = [err69];
}
else {
vErrors.push(err69);
}
errors++;
}
}
}
}
else {
const err70 = {};
if(vErrors === null){
vErrors = [err70];
}
else {
vErrors.push(err70);
}
errors++;
}
}
var valid66 = _errs117 === errors;
if(valid66){
break;
}
}
if(!valid66){
const err71 = {};
if(vErrors === null){
vErrors = [err71];
}
else {
vErrors.push(err71);
}
errors++;
}
else {
errors = _errs116;
if(vErrors !== null){
if(_errs116){
vErrors.length = _errs116;
}
else {
vErrors = null;
}
}
}
}
var valid65 = _errs115 === errors;
if(valid65){
const err72 = {instancePath:instancePath+"/targetOverlays",schemaPath:"#/allOf/8/else/properties/targetOverlays/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err72];
}
else {
vErrors.push(err72);
}
errors++;
}
else {
errors = _errs114;
if(vErrors !== null){
if(_errs114){
vErrors.length = _errs114;
}
else {
vErrors = null;
}
}
}
}
}
var _valid10 = _errs112 === errors;
valid57 = _valid10;
if(valid57){
if(props8 !== true){
props8 = props8 || {};
props8.targetOverlays = true;
}
}
ifClause2 = "else";
}
if(!valid57){
const err73 = {instancePath,schemaPath:"#/allOf/8/if",keyword:"if",params:{failingKeyword: ifClause2},message:"must match \""+ifClause2+"\" schema"};
if(vErrors === null){
vErrors = [err73];
}
else {
vErrors.push(err73);
}
errors++;
}
if(props0 !== true && props8 !== undefined){
if(props8 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props8);
}
}
const _errs122 = errors;
let valid69 = true;
const _errs123 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing11;
if((data.renderTargets === undefined) && (missing11 = "renderTargets")){
const err74 = {};
if(vErrors === null){
vErrors = [err74];
}
else {
vErrors.push(err74);
}
errors++;
}
else {
if(data.renderTargets !== undefined){
let data52 = data.renderTargets;
if(Array.isArray(data52)){
const _errs125 = errors;
const len16 = data52.length;
for(let i16=0; i16<len16; i16++){
const _errs126 = errors;
if("xlsx" !== data52[i16]){
const err75 = {};
if(vErrors === null){
vErrors = [err75];
}
else {
vErrors.push(err75);
}
errors++;
}
var valid71 = _errs126 === errors;
if(valid71){
break;
}
}
if(!valid71){
const err76 = {};
if(vErrors === null){
vErrors = [err76];
}
else {
vErrors.push(err76);
}
errors++;
}
else {
errors = _errs125;
if(vErrors !== null){
if(_errs125){
vErrors.length = _errs125;
}
else {
vErrors = null;
}
}
}
}
}
}
}
var _valid12 = _errs123 === errors;
errors = _errs122;
if(vErrors !== null){
if(_errs122){
vErrors.length = _errs122;
}
else {
vErrors = null;
}
}
let ifClause3;
if(_valid12){
const _errs127 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.targetOverlays !== undefined){
let data54 = data.targetOverlays;
if(Array.isArray(data54)){
const _errs129 = errors;
const len17 = data54.length;
let valid73 = false;
let count3 = 0;
for(let i17=0; i17<len17; i17++){
let data55 = data54[i17];
const _errs130 = errors;
if(data55 && typeof data55 == "object" && !Array.isArray(data55)){
if(data55.target === undefined){
const err77 = {instancePath:instancePath+"/targetOverlays/" + i17,schemaPath:"#/$defs/XlsxOverlaySelector/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err77];
}
else {
vErrors.push(err77);
}
errors++;
}
if(data55.target !== undefined){
if("xlsx" !== data55.target){
const err78 = {instancePath:instancePath+"/targetOverlays/" + i17+"/target",schemaPath:"#/$defs/XlsxOverlaySelector/properties/target/const",keyword:"const",params:{allowedValue: "xlsx"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err78];
}
else {
vErrors.push(err78);
}
errors++;
}
}
}
else {
const err79 = {instancePath:instancePath+"/targetOverlays/" + i17,schemaPath:"#/$defs/XlsxOverlaySelector/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err79];
}
else {
vErrors.push(err79);
}
errors++;
}
var _valid13 = _errs130 === errors;
if(_valid13){
count3++;
if(count3 > 1){
valid73 = false;
break;
}
valid73 = true;
}
}
if(!valid73){
const err80 = {instancePath:instancePath+"/targetOverlays",schemaPath:"#/allOf/9/then/properties/targetOverlays/contains",keyword:"contains",params:{minContains: 1, maxContains: 1},message:"must contain at least 1 and no more than 1 valid item(s)"};
if(vErrors === null){
vErrors = [err80];
}
else {
vErrors.push(err80);
}
errors++;
}
else {
errors = _errs129;
if(vErrors !== null){
if(_errs129){
vErrors.length = _errs129;
}
else {
vErrors = null;
}
}
}
}
}
}
var _valid12 = _errs127 === errors;
valid69 = _valid12;
if(valid69){
var props9 = {};
props9.targetOverlays = true;
props9.renderTargets = true;
}
ifClause3 = "then";
}
else {
const _errs134 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.targetOverlays !== undefined){
let data57 = data.targetOverlays;
const _errs136 = errors;
const _errs137 = errors;
if(Array.isArray(data57)){
const _errs138 = errors;
const len18 = data57.length;
for(let i18=0; i18<len18; i18++){
let data58 = data57[i18];
const _errs139 = errors;
const _errs140 = errors;
if(errors === _errs140){
if(data58 && typeof data58 == "object" && !Array.isArray(data58)){
let missing12;
if((data58.target === undefined) && (missing12 = "target")){
const err81 = {};
if(vErrors === null){
vErrors = [err81];
}
else {
vErrors.push(err81);
}
errors++;
}
else {
if(data58.target !== undefined){
if("xlsx" !== data58.target){
const err82 = {};
if(vErrors === null){
vErrors = [err82];
}
else {
vErrors.push(err82);
}
errors++;
}
}
}
}
else {
const err83 = {};
if(vErrors === null){
vErrors = [err83];
}
else {
vErrors.push(err83);
}
errors++;
}
}
var valid78 = _errs139 === errors;
if(valid78){
break;
}
}
if(!valid78){
const err84 = {};
if(vErrors === null){
vErrors = [err84];
}
else {
vErrors.push(err84);
}
errors++;
}
else {
errors = _errs138;
if(vErrors !== null){
if(_errs138){
vErrors.length = _errs138;
}
else {
vErrors = null;
}
}
}
}
var valid77 = _errs137 === errors;
if(valid77){
const err85 = {instancePath:instancePath+"/targetOverlays",schemaPath:"#/allOf/9/else/properties/targetOverlays/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err85];
}
else {
vErrors.push(err85);
}
errors++;
}
else {
errors = _errs136;
if(vErrors !== null){
if(_errs136){
vErrors.length = _errs136;
}
else {
vErrors = null;
}
}
}
}
}
var _valid12 = _errs134 === errors;
valid69 = _valid12;
if(valid69){
if(props9 !== true){
props9 = props9 || {};
props9.targetOverlays = true;
}
}
ifClause3 = "else";
}
if(!valid69){
const err86 = {instancePath,schemaPath:"#/allOf/9/if",keyword:"if",params:{failingKeyword: ifClause3},message:"must match \""+ifClause3+"\" schema"};
if(vErrors === null){
vErrors = [err86];
}
else {
vErrors.push(err86);
}
errors++;
}
if(props0 !== true && props9 !== undefined){
if(props9 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props9);
}
}
const _errs144 = errors;
let valid81 = true;
const _errs145 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing13;
if((data.renderTargets === undefined) && (missing13 = "renderTargets")){
const err87 = {};
if(vErrors === null){
vErrors = [err87];
}
else {
vErrors.push(err87);
}
errors++;
}
else {
if(data.renderTargets !== undefined){
let data60 = data.renderTargets;
if(Array.isArray(data60)){
const _errs147 = errors;
const len19 = data60.length;
for(let i19=0; i19<len19; i19++){
const _errs148 = errors;
if("pdf" !== data60[i19]){
const err88 = {};
if(vErrors === null){
vErrors = [err88];
}
else {
vErrors.push(err88);
}
errors++;
}
var valid83 = _errs148 === errors;
if(valid83){
break;
}
}
if(!valid83){
const err89 = {};
if(vErrors === null){
vErrors = [err89];
}
else {
vErrors.push(err89);
}
errors++;
}
else {
errors = _errs147;
if(vErrors !== null){
if(_errs147){
vErrors.length = _errs147;
}
else {
vErrors = null;
}
}
}
}
}
}
}
var _valid14 = _errs145 === errors;
errors = _errs144;
if(vErrors !== null){
if(_errs144){
vErrors.length = _errs144;
}
else {
vErrors = null;
}
}
let ifClause4;
if(_valid14){
const _errs149 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.targetOverlays !== undefined){
let data62 = data.targetOverlays;
if(Array.isArray(data62)){
const _errs151 = errors;
const len20 = data62.length;
let valid85 = false;
let count4 = 0;
for(let i20=0; i20<len20; i20++){
let data63 = data62[i20];
const _errs152 = errors;
if(data63 && typeof data63 == "object" && !Array.isArray(data63)){
if(data63.target === undefined){
const err90 = {instancePath:instancePath+"/targetOverlays/" + i20,schemaPath:"#/$defs/PdfOverlaySelector/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err90];
}
else {
vErrors.push(err90);
}
errors++;
}
if(data63.target !== undefined){
if("pdf" !== data63.target){
const err91 = {instancePath:instancePath+"/targetOverlays/" + i20+"/target",schemaPath:"#/$defs/PdfOverlaySelector/properties/target/const",keyword:"const",params:{allowedValue: "pdf"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err91];
}
else {
vErrors.push(err91);
}
errors++;
}
}
}
else {
const err92 = {instancePath:instancePath+"/targetOverlays/" + i20,schemaPath:"#/$defs/PdfOverlaySelector/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err92];
}
else {
vErrors.push(err92);
}
errors++;
}
var _valid15 = _errs152 === errors;
if(_valid15){
count4++;
if(count4 > 1){
valid85 = false;
break;
}
valid85 = true;
}
}
if(!valid85){
const err93 = {instancePath:instancePath+"/targetOverlays",schemaPath:"#/allOf/10/then/properties/targetOverlays/contains",keyword:"contains",params:{minContains: 1, maxContains: 1},message:"must contain at least 1 and no more than 1 valid item(s)"};
if(vErrors === null){
vErrors = [err93];
}
else {
vErrors.push(err93);
}
errors++;
}
else {
errors = _errs151;
if(vErrors !== null){
if(_errs151){
vErrors.length = _errs151;
}
else {
vErrors = null;
}
}
}
}
}
}
var _valid14 = _errs149 === errors;
valid81 = _valid14;
if(valid81){
var props10 = {};
props10.targetOverlays = true;
props10.renderTargets = true;
}
ifClause4 = "then";
}
else {
const _errs156 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.targetOverlays !== undefined){
let data65 = data.targetOverlays;
const _errs158 = errors;
const _errs159 = errors;
if(Array.isArray(data65)){
const _errs160 = errors;
const len21 = data65.length;
for(let i21=0; i21<len21; i21++){
let data66 = data65[i21];
const _errs161 = errors;
const _errs162 = errors;
if(errors === _errs162){
if(data66 && typeof data66 == "object" && !Array.isArray(data66)){
let missing14;
if((data66.target === undefined) && (missing14 = "target")){
const err94 = {};
if(vErrors === null){
vErrors = [err94];
}
else {
vErrors.push(err94);
}
errors++;
}
else {
if(data66.target !== undefined){
if("pdf" !== data66.target){
const err95 = {};
if(vErrors === null){
vErrors = [err95];
}
else {
vErrors.push(err95);
}
errors++;
}
}
}
}
else {
const err96 = {};
if(vErrors === null){
vErrors = [err96];
}
else {
vErrors.push(err96);
}
errors++;
}
}
var valid90 = _errs161 === errors;
if(valid90){
break;
}
}
if(!valid90){
const err97 = {};
if(vErrors === null){
vErrors = [err97];
}
else {
vErrors.push(err97);
}
errors++;
}
else {
errors = _errs160;
if(vErrors !== null){
if(_errs160){
vErrors.length = _errs160;
}
else {
vErrors = null;
}
}
}
}
var valid89 = _errs159 === errors;
if(valid89){
const err98 = {instancePath:instancePath+"/targetOverlays",schemaPath:"#/allOf/10/else/properties/targetOverlays/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err98];
}
else {
vErrors.push(err98);
}
errors++;
}
else {
errors = _errs158;
if(vErrors !== null){
if(_errs158){
vErrors.length = _errs158;
}
else {
vErrors = null;
}
}
}
}
}
var _valid14 = _errs156 === errors;
valid81 = _valid14;
if(valid81){
if(props10 !== true){
props10 = props10 || {};
props10.targetOverlays = true;
}
}
ifClause4 = "else";
}
if(!valid81){
const err99 = {instancePath,schemaPath:"#/allOf/10/if",keyword:"if",params:{failingKeyword: ifClause4},message:"must match \""+ifClause4+"\" schema"};
if(vErrors === null){
vErrors = [err99];
}
else {
vErrors.push(err99);
}
errors++;
}
if(props0 !== true && props10 !== undefined){
if(props10 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props10);
}
}
const _errs166 = errors;
let valid93 = true;
const _errs167 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing15;
if((data.publicationTargets === undefined) && (missing15 = "publicationTargets")){
const err100 = {};
if(vErrors === null){
vErrors = [err100];
}
else {
vErrors.push(err100);
}
errors++;
}
else {
if(data.publicationTargets !== undefined){
let data68 = data.publicationTargets;
if(Array.isArray(data68)){
const _errs169 = errors;
const len22 = data68.length;
for(let i22=0; i22<len22; i22++){
const _errs170 = errors;
if("google-docs" !== data68[i22]){
const err101 = {};
if(vErrors === null){
vErrors = [err101];
}
else {
vErrors.push(err101);
}
errors++;
}
var valid95 = _errs170 === errors;
if(valid95){
break;
}
}
if(!valid95){
const err102 = {};
if(vErrors === null){
vErrors = [err102];
}
else {
vErrors.push(err102);
}
errors++;
}
else {
errors = _errs169;
if(vErrors !== null){
if(_errs169){
vErrors.length = _errs169;
}
else {
vErrors = null;
}
}
}
}
}
}
}
var _valid16 = _errs167 === errors;
errors = _errs166;
if(vErrors !== null){
if(_errs166){
vErrors.length = _errs166;
}
else {
vErrors = null;
}
}
let ifClause5;
if(_valid16){
const _errs171 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.targetOverlays !== undefined){
let data70 = data.targetOverlays;
if(Array.isArray(data70)){
const _errs173 = errors;
const len23 = data70.length;
let valid97 = false;
let count5 = 0;
for(let i23=0; i23<len23; i23++){
let data71 = data70[i23];
const _errs174 = errors;
if(data71 && typeof data71 == "object" && !Array.isArray(data71)){
if(data71.target === undefined){
const err103 = {instancePath:instancePath+"/targetOverlays/" + i23,schemaPath:"#/$defs/GoogleDocsOverlaySelector/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err103];
}
else {
vErrors.push(err103);
}
errors++;
}
if(data71.target !== undefined){
if("google-docs" !== data71.target){
const err104 = {instancePath:instancePath+"/targetOverlays/" + i23+"/target",schemaPath:"#/$defs/GoogleDocsOverlaySelector/properties/target/const",keyword:"const",params:{allowedValue: "google-docs"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err104];
}
else {
vErrors.push(err104);
}
errors++;
}
}
}
else {
const err105 = {instancePath:instancePath+"/targetOverlays/" + i23,schemaPath:"#/$defs/GoogleDocsOverlaySelector/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err105];
}
else {
vErrors.push(err105);
}
errors++;
}
var _valid17 = _errs174 === errors;
if(_valid17){
count5++;
if(count5 > 1){
valid97 = false;
break;
}
valid97 = true;
}
}
if(!valid97){
const err106 = {instancePath:instancePath+"/targetOverlays",schemaPath:"#/allOf/11/then/properties/targetOverlays/contains",keyword:"contains",params:{minContains: 1, maxContains: 1},message:"must contain at least 1 and no more than 1 valid item(s)"};
if(vErrors === null){
vErrors = [err106];
}
else {
vErrors.push(err106);
}
errors++;
}
else {
errors = _errs173;
if(vErrors !== null){
if(_errs173){
vErrors.length = _errs173;
}
else {
vErrors = null;
}
}
}
}
}
}
var _valid16 = _errs171 === errors;
valid93 = _valid16;
if(valid93){
var props11 = {};
props11.targetOverlays = true;
props11.publicationTargets = true;
}
ifClause5 = "then";
}
else {
const _errs178 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.targetOverlays !== undefined){
let data73 = data.targetOverlays;
const _errs180 = errors;
const _errs181 = errors;
if(Array.isArray(data73)){
const _errs182 = errors;
const len24 = data73.length;
for(let i24=0; i24<len24; i24++){
let data74 = data73[i24];
const _errs183 = errors;
const _errs184 = errors;
if(errors === _errs184){
if(data74 && typeof data74 == "object" && !Array.isArray(data74)){
let missing16;
if((data74.target === undefined) && (missing16 = "target")){
const err107 = {};
if(vErrors === null){
vErrors = [err107];
}
else {
vErrors.push(err107);
}
errors++;
}
else {
if(data74.target !== undefined){
if("google-docs" !== data74.target){
const err108 = {};
if(vErrors === null){
vErrors = [err108];
}
else {
vErrors.push(err108);
}
errors++;
}
}
}
}
else {
const err109 = {};
if(vErrors === null){
vErrors = [err109];
}
else {
vErrors.push(err109);
}
errors++;
}
}
var valid102 = _errs183 === errors;
if(valid102){
break;
}
}
if(!valid102){
const err110 = {};
if(vErrors === null){
vErrors = [err110];
}
else {
vErrors.push(err110);
}
errors++;
}
else {
errors = _errs182;
if(vErrors !== null){
if(_errs182){
vErrors.length = _errs182;
}
else {
vErrors = null;
}
}
}
}
var valid101 = _errs181 === errors;
if(valid101){
const err111 = {instancePath:instancePath+"/targetOverlays",schemaPath:"#/allOf/11/else/properties/targetOverlays/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err111];
}
else {
vErrors.push(err111);
}
errors++;
}
else {
errors = _errs180;
if(vErrors !== null){
if(_errs180){
vErrors.length = _errs180;
}
else {
vErrors = null;
}
}
}
}
}
var _valid16 = _errs178 === errors;
valid93 = _valid16;
if(valid93){
if(props11 !== true){
props11 = props11 || {};
props11.targetOverlays = true;
}
}
ifClause5 = "else";
}
if(!valid93){
const err112 = {instancePath,schemaPath:"#/allOf/11/if",keyword:"if",params:{failingKeyword: ifClause5},message:"must match \""+ifClause5+"\" schema"};
if(vErrors === null){
vErrors = [err112];
}
else {
vErrors.push(err112);
}
errors++;
}
if(props0 !== true && props11 !== undefined){
if(props11 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props11);
}
}
const _errs188 = errors;
let valid105 = true;
const _errs189 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing17;
if((data.publicationTargets === undefined) && (missing17 = "publicationTargets")){
const err113 = {};
if(vErrors === null){
vErrors = [err113];
}
else {
vErrors.push(err113);
}
errors++;
}
else {
if(data.publicationTargets !== undefined){
let data76 = data.publicationTargets;
if(Array.isArray(data76)){
const _errs191 = errors;
const len25 = data76.length;
for(let i25=0; i25<len25; i25++){
const _errs192 = errors;
if("notion" !== data76[i25]){
const err114 = {};
if(vErrors === null){
vErrors = [err114];
}
else {
vErrors.push(err114);
}
errors++;
}
var valid107 = _errs192 === errors;
if(valid107){
break;
}
}
if(!valid107){
const err115 = {};
if(vErrors === null){
vErrors = [err115];
}
else {
vErrors.push(err115);
}
errors++;
}
else {
errors = _errs191;
if(vErrors !== null){
if(_errs191){
vErrors.length = _errs191;
}
else {
vErrors = null;
}
}
}
}
}
}
}
var _valid18 = _errs189 === errors;
errors = _errs188;
if(vErrors !== null){
if(_errs188){
vErrors.length = _errs188;
}
else {
vErrors = null;
}
}
let ifClause6;
if(_valid18){
const _errs193 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.targetOverlays !== undefined){
let data78 = data.targetOverlays;
if(Array.isArray(data78)){
const _errs195 = errors;
const len26 = data78.length;
let valid109 = false;
let count6 = 0;
for(let i26=0; i26<len26; i26++){
let data79 = data78[i26];
const _errs196 = errors;
if(data79 && typeof data79 == "object" && !Array.isArray(data79)){
if(data79.target === undefined){
const err116 = {instancePath:instancePath+"/targetOverlays/" + i26,schemaPath:"#/$defs/NotionOverlaySelector/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err116];
}
else {
vErrors.push(err116);
}
errors++;
}
if(data79.target !== undefined){
if("notion" !== data79.target){
const err117 = {instancePath:instancePath+"/targetOverlays/" + i26+"/target",schemaPath:"#/$defs/NotionOverlaySelector/properties/target/const",keyword:"const",params:{allowedValue: "notion"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err117];
}
else {
vErrors.push(err117);
}
errors++;
}
}
}
else {
const err118 = {instancePath:instancePath+"/targetOverlays/" + i26,schemaPath:"#/$defs/NotionOverlaySelector/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err118];
}
else {
vErrors.push(err118);
}
errors++;
}
var _valid19 = _errs196 === errors;
if(_valid19){
count6++;
if(count6 > 1){
valid109 = false;
break;
}
valid109 = true;
}
}
if(!valid109){
const err119 = {instancePath:instancePath+"/targetOverlays",schemaPath:"#/allOf/12/then/properties/targetOverlays/contains",keyword:"contains",params:{minContains: 1, maxContains: 1},message:"must contain at least 1 and no more than 1 valid item(s)"};
if(vErrors === null){
vErrors = [err119];
}
else {
vErrors.push(err119);
}
errors++;
}
else {
errors = _errs195;
if(vErrors !== null){
if(_errs195){
vErrors.length = _errs195;
}
else {
vErrors = null;
}
}
}
}
}
}
var _valid18 = _errs193 === errors;
valid105 = _valid18;
if(valid105){
var props12 = {};
props12.targetOverlays = true;
props12.publicationTargets = true;
}
ifClause6 = "then";
}
else {
const _errs200 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.targetOverlays !== undefined){
let data81 = data.targetOverlays;
const _errs202 = errors;
const _errs203 = errors;
if(Array.isArray(data81)){
const _errs204 = errors;
const len27 = data81.length;
for(let i27=0; i27<len27; i27++){
let data82 = data81[i27];
const _errs205 = errors;
const _errs206 = errors;
if(errors === _errs206){
if(data82 && typeof data82 == "object" && !Array.isArray(data82)){
let missing18;
if((data82.target === undefined) && (missing18 = "target")){
const err120 = {};
if(vErrors === null){
vErrors = [err120];
}
else {
vErrors.push(err120);
}
errors++;
}
else {
if(data82.target !== undefined){
if("notion" !== data82.target){
const err121 = {};
if(vErrors === null){
vErrors = [err121];
}
else {
vErrors.push(err121);
}
errors++;
}
}
}
}
else {
const err122 = {};
if(vErrors === null){
vErrors = [err122];
}
else {
vErrors.push(err122);
}
errors++;
}
}
var valid114 = _errs205 === errors;
if(valid114){
break;
}
}
if(!valid114){
const err123 = {};
if(vErrors === null){
vErrors = [err123];
}
else {
vErrors.push(err123);
}
errors++;
}
else {
errors = _errs204;
if(vErrors !== null){
if(_errs204){
vErrors.length = _errs204;
}
else {
vErrors = null;
}
}
}
}
var valid113 = _errs203 === errors;
if(valid113){
const err124 = {instancePath:instancePath+"/targetOverlays",schemaPath:"#/allOf/12/else/properties/targetOverlays/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err124];
}
else {
vErrors.push(err124);
}
errors++;
}
else {
errors = _errs202;
if(vErrors !== null){
if(_errs202){
vErrors.length = _errs202;
}
else {
vErrors = null;
}
}
}
}
}
var _valid18 = _errs200 === errors;
valid105 = _valid18;
if(valid105){
if(props12 !== true){
props12 = props12 || {};
props12.targetOverlays = true;
}
}
ifClause6 = "else";
}
if(!valid105){
const err125 = {instancePath,schemaPath:"#/allOf/12/if",keyword:"if",params:{failingKeyword: ifClause6},message:"must match \""+ifClause6+"\" schema"};
if(vErrors === null){
vErrors = [err125];
}
else {
vErrors.push(err125);
}
errors++;
}
if(props0 !== true && props12 !== undefined){
if(props12 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props12);
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.variantId === undefined){
const err126 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "variantId"},message:"must have required property '"+"variantId"+"'"};
if(vErrors === null){
vErrors = [err126];
}
else {
vErrors.push(err126);
}
errors++;
}
if(data.name === undefined){
const err127 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err127];
}
else {
vErrors.push(err127);
}
errors++;
}
if(data.layoutProfile === undefined){
const err128 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "layoutProfile"},message:"must have required property '"+"layoutProfile"+"'"};
if(vErrors === null){
vErrors = [err128];
}
else {
vErrors.push(err128);
}
errors++;
}
if(data.capabilityStatus === undefined){
const err129 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "capabilityStatus"},message:"must have required property '"+"capabilityStatus"+"'"};
if(vErrors === null){
vErrors = [err129];
}
else {
vErrors.push(err129);
}
errors++;
}
if(data.knownLimitations === undefined){
const err130 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "knownLimitations"},message:"must have required property '"+"knownLimitations"+"'"};
if(vErrors === null){
vErrors = [err130];
}
else {
vErrors.push(err130);
}
errors++;
}
if(data.layout === undefined){
const err131 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "layout"},message:"must have required property '"+"layout"+"'"};
if(vErrors === null){
vErrors = [err131];
}
else {
vErrors.push(err131);
}
errors++;
}
if(data.sourcePolicy === undefined){
const err132 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sourcePolicy"},message:"must have required property '"+"sourcePolicy"+"'"};
if(vErrors === null){
vErrors = [err132];
}
else {
vErrors.push(err132);
}
errors++;
}
if(data.slotBindings === undefined){
const err133 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "slotBindings"},message:"must have required property '"+"slotBindings"+"'"};
if(vErrors === null){
vErrors = [err133];
}
else {
vErrors.push(err133);
}
errors++;
}
if(data.approvedOmissions === undefined){
const err134 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "approvedOmissions"},message:"must have required property '"+"approvedOmissions"+"'"};
if(vErrors === null){
vErrors = [err134];
}
else {
vErrors.push(err134);
}
errors++;
}
if(data.renderTargets === undefined){
const err135 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "renderTargets"},message:"must have required property '"+"renderTargets"+"'"};
if(vErrors === null){
vErrors = [err135];
}
else {
vErrors.push(err135);
}
errors++;
}
if(data.publicationTargets === undefined){
const err136 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "publicationTargets"},message:"must have required property '"+"publicationTargets"+"'"};
if(vErrors === null){
vErrors = [err136];
}
else {
vErrors.push(err136);
}
errors++;
}
if(data.targetOverlays === undefined){
const err137 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "targetOverlays"},message:"must have required property '"+"targetOverlays"+"'"};
if(vErrors === null){
vErrors = [err137];
}
else {
vErrors.push(err137);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema76.properties, key0))){
const err138 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err138];
}
else {
vErrors.push(err138);
}
errors++;
}
}
if(data.variantId !== undefined){
let data84 = data.variantId;
if(typeof data84 === "string"){
if(!pattern4.test(data84)){
const err139 = {instancePath:instancePath+"/variantId",schemaPath:"#/$defs/KebabId/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9]+(?:-[a-z0-9]+)*$"},message:"must match pattern \""+"^[a-z0-9]+(?:-[a-z0-9]+)*$"+"\""};
if(vErrors === null){
vErrors = [err139];
}
else {
vErrors.push(err139);
}
errors++;
}
}
else {
const err140 = {instancePath:instancePath+"/variantId",schemaPath:"#/$defs/KebabId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err140];
}
else {
vErrors.push(err140);
}
errors++;
}
}
if(data.name !== undefined){
let data85 = data.name;
if(typeof data85 === "string"){
if(func2(data85) < 1){
const err141 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err141];
}
else {
vErrors.push(err141);
}
errors++;
}
}
else {
const err142 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err142];
}
else {
vErrors.push(err142);
}
errors++;
}
}
if(data.layoutProfile !== undefined){
let data86 = data.layoutProfile;
if(!((((data86 === "flow-page") || (data86 === "fixed-page")) || (data86 === "workbook")) || (data86 === "block-page"))){
const err143 = {instancePath:instancePath+"/layoutProfile",schemaPath:"#/properties/layoutProfile/enum",keyword:"enum",params:{allowedValues: schema76.properties.layoutProfile.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err143];
}
else {
vErrors.push(err143);
}
errors++;
}
}
if(data.capabilityStatus !== undefined){
let data87 = data.capabilityStatus;
if(!(((data87 === "production-ready") || (data87 === "partial")) || (data87 === "planned"))){
const err144 = {instancePath:instancePath+"/capabilityStatus",schemaPath:"#/properties/capabilityStatus/enum",keyword:"enum",params:{allowedValues: schema76.properties.capabilityStatus.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err144];
}
else {
vErrors.push(err144);
}
errors++;
}
}
if(data.knownLimitations !== undefined){
let data88 = data.knownLimitations;
if(Array.isArray(data88)){
const len28 = data88.length;
for(let i28=0; i28<len28; i28++){
let data89 = data88[i28];
if(typeof data89 === "string"){
if(func2(data89) < 1){
const err145 = {instancePath:instancePath+"/knownLimitations/" + i28,schemaPath:"#/properties/knownLimitations/items/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err145];
}
else {
vErrors.push(err145);
}
errors++;
}
}
else {
const err146 = {instancePath:instancePath+"/knownLimitations/" + i28,schemaPath:"#/properties/knownLimitations/items/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err146];
}
else {
vErrors.push(err146);
}
errors++;
}
}
let i29 = data88.length;
let j0;
if(i29 > 1){
const indices0 = {};
for(;i29--;){
let item0 = data88[i29];
if(typeof item0 !== "string"){
continue;
}
if(typeof indices0[item0] == "number"){
j0 = indices0[item0];
const err147 = {instancePath:instancePath+"/knownLimitations",schemaPath:"#/properties/knownLimitations/uniqueItems",keyword:"uniqueItems",params:{i: i29, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i29+" are identical)"};
if(vErrors === null){
vErrors = [err147];
}
else {
vErrors.push(err147);
}
errors++;
break;
}
indices0[item0] = i29;
}
}
}
else {
const err148 = {instancePath:instancePath+"/knownLimitations",schemaPath:"#/properties/knownLimitations/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err148];
}
else {
vErrors.push(err148);
}
errors++;
}
}
if(data.layout !== undefined){
let data90 = data.layout;
const _errs222 = errors;
let valid122 = false;
let passing0 = null;
const _errs223 = errors;
if(!(validate46(data90, {instancePath:instancePath+"/layout",parentData:data,parentDataProperty:"layout",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate46.errors : vErrors.concat(validate46.errors);
errors = vErrors.length;
}
var _valid20 = _errs223 === errors;
if(_valid20){
valid122 = true;
passing0 = 0;
var props13 = true;
}
const _errs224 = errors;
if(!(validate48(data90, {instancePath:instancePath+"/layout",parentData:data,parentDataProperty:"layout",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate48.errors : vErrors.concat(validate48.errors);
errors = vErrors.length;
}
var _valid20 = _errs224 === errors;
if(_valid20 && valid122){
valid122 = false;
passing0 = [passing0, 1];
}
else {
if(_valid20){
valid122 = true;
passing0 = 1;
if(props13 !== true){
props13 = true;
}
}
const _errs225 = errors;
if(!(validate50(data90, {instancePath:instancePath+"/layout",parentData:data,parentDataProperty:"layout",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate50.errors : vErrors.concat(validate50.errors);
errors = vErrors.length;
}
var _valid20 = _errs225 === errors;
if(_valid20 && valid122){
valid122 = false;
passing0 = [passing0, 2];
}
else {
if(_valid20){
valid122 = true;
passing0 = 2;
if(props13 !== true){
props13 = true;
}
}
const _errs226 = errors;
if(!(validate52(data90, {instancePath:instancePath+"/layout",parentData:data,parentDataProperty:"layout",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate52.errors : vErrors.concat(validate52.errors);
errors = vErrors.length;
}
var _valid20 = _errs226 === errors;
if(_valid20 && valid122){
valid122 = false;
passing0 = [passing0, 3];
}
else {
if(_valid20){
valid122 = true;
passing0 = 3;
if(props13 !== true){
props13 = true;
}
}
}
}
}
if(!valid122){
const err149 = {instancePath:instancePath+"/layout",schemaPath:"#/properties/layout/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err149];
}
else {
vErrors.push(err149);
}
errors++;
}
else {
errors = _errs222;
if(vErrors !== null){
if(_errs222){
vErrors.length = _errs222;
}
else {
vErrors = null;
}
}
}
}
if(data.sourcePolicy !== undefined){
let data91 = data.sourcePolicy;
if(data91 && typeof data91 == "object" && !Array.isArray(data91)){
if(data91.canonicalModel === undefined){
const err150 = {instancePath:instancePath+"/sourcePolicy",schemaPath:"#/$defs/SourcePolicy/required",keyword:"required",params:{missingProperty: "canonicalModel"},message:"must have required property '"+"canonicalModel"+"'"};
if(vErrors === null){
vErrors = [err150];
}
else {
vErrors.push(err150);
}
errors++;
}
if(data91.editorAdapters === undefined){
const err151 = {instancePath:instancePath+"/sourcePolicy",schemaPath:"#/$defs/SourcePolicy/required",keyword:"required",params:{missingProperty: "editorAdapters"},message:"must have required property '"+"editorAdapters"+"'"};
if(vErrors === null){
vErrors = [err151];
}
else {
vErrors.push(err151);
}
errors++;
}
if(data91.adapterCanonicalAuthority === undefined){
const err152 = {instancePath:instancePath+"/sourcePolicy",schemaPath:"#/$defs/SourcePolicy/required",keyword:"required",params:{missingProperty: "adapterCanonicalAuthority"},message:"must have required property '"+"adapterCanonicalAuthority"+"'"};
if(vErrors === null){
vErrors = [err152];
}
else {
vErrors.push(err152);
}
errors++;
}
for(const key1 in data91){
if(!(((key1 === "canonicalModel") || (key1 === "editorAdapters")) || (key1 === "adapterCanonicalAuthority"))){
const err153 = {instancePath:instancePath+"/sourcePolicy",schemaPath:"#/$defs/SourcePolicy/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err153];
}
else {
vErrors.push(err153);
}
errors++;
}
}
if(data91.canonicalModel !== undefined){
if("cogo-document-template-family" !== data91.canonicalModel){
const err154 = {instancePath:instancePath+"/sourcePolicy/canonicalModel",schemaPath:"#/$defs/SourcePolicy/properties/canonicalModel/const",keyword:"const",params:{allowedValue: "cogo-document-template-family"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err154];
}
else {
vErrors.push(err154);
}
errors++;
}
}
if(data91.editorAdapters !== undefined){
let data93 = data91.editorAdapters;
if(Array.isArray(data93)){
if(data93.length < 1){
const err155 = {instancePath:instancePath+"/sourcePolicy/editorAdapters",schemaPath:"#/$defs/SourcePolicy/properties/editorAdapters/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err155];
}
else {
vErrors.push(err155);
}
errors++;
}
const len29 = data93.length;
for(let i30=0; i30<len29; i30++){
let data94 = data93[i30];
if(!(((((((data94 === "wordgard") || (data94 === "cogo-fixed-page-editor")) || (data94 === "univer")) || (data94 === "cogo-block-editor")) || (data94 === "openpencil")) || (data94 === "google-docs")) || (data94 === "notion"))){
const err156 = {instancePath:instancePath+"/sourcePolicy/editorAdapters/" + i30,schemaPath:"#/$defs/SourcePolicy/properties/editorAdapters/items/enum",keyword:"enum",params:{allowedValues: schema101.properties.editorAdapters.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err156];
}
else {
vErrors.push(err156);
}
errors++;
}
}
let i31 = data93.length;
let j1;
if(i31 > 1){
outer0:
for(;i31--;){
for(j1 = i31; j1--;){
if(func0(data93[i31], data93[j1])){
const err157 = {instancePath:instancePath+"/sourcePolicy/editorAdapters",schemaPath:"#/$defs/SourcePolicy/properties/editorAdapters/uniqueItems",keyword:"uniqueItems",params:{i: i31, j: j1},message:"must NOT have duplicate items (items ## "+j1+" and "+i31+" are identical)"};
if(vErrors === null){
vErrors = [err157];
}
else {
vErrors.push(err157);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err158 = {instancePath:instancePath+"/sourcePolicy/editorAdapters",schemaPath:"#/$defs/SourcePolicy/properties/editorAdapters/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err158];
}
else {
vErrors.push(err158);
}
errors++;
}
}
if(data91.adapterCanonicalAuthority !== undefined){
if(false !== data91.adapterCanonicalAuthority){
const err159 = {instancePath:instancePath+"/sourcePolicy/adapterCanonicalAuthority",schemaPath:"#/$defs/SourcePolicy/properties/adapterCanonicalAuthority/const",keyword:"const",params:{allowedValue: false},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err159];
}
else {
vErrors.push(err159);
}
errors++;
}
}
}
else {
const err160 = {instancePath:instancePath+"/sourcePolicy",schemaPath:"#/$defs/SourcePolicy/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err160];
}
else {
vErrors.push(err160);
}
errors++;
}
}
if(data.slotBindings !== undefined){
let data96 = data.slotBindings;
if(Array.isArray(data96)){
const len30 = data96.length;
for(let i32=0; i32<len30; i32++){
if(!(validate58(data96[i32], {instancePath:instancePath+"/slotBindings/" + i32,parentData:data96,parentDataProperty:i32,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate58.errors : vErrors.concat(validate58.errors);
errors = vErrors.length;
}
}
}
else {
const err161 = {instancePath:instancePath+"/slotBindings",schemaPath:"#/properties/slotBindings/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err161];
}
else {
vErrors.push(err161);
}
errors++;
}
}
if(data.approvedOmissions !== undefined){
let data98 = data.approvedOmissions;
if(Array.isArray(data98)){
const len31 = data98.length;
for(let i33=0; i33<len31; i33++){
if(!(validate60(data98[i33], {instancePath:instancePath+"/approvedOmissions/" + i33,parentData:data98,parentDataProperty:i33,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate60.errors : vErrors.concat(validate60.errors);
errors = vErrors.length;
}
}
}
else {
const err162 = {instancePath:instancePath+"/approvedOmissions",schemaPath:"#/properties/approvedOmissions/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err162];
}
else {
vErrors.push(err162);
}
errors++;
}
}
if(data.renderTargets !== undefined){
let data100 = data.renderTargets;
if(Array.isArray(data100)){
const len32 = data100.length;
for(let i34=0; i34<len32; i34++){
let data101 = data100[i34];
if(!(((((data101 === "docx") || (data101 === "hwpx")) || (data101 === "pptx")) || (data101 === "xlsx")) || (data101 === "pdf"))){
const err163 = {instancePath:instancePath+"/renderTargets/" + i34,schemaPath:"#/properties/renderTargets/items/enum",keyword:"enum",params:{allowedValues: schema76.properties.renderTargets.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err163];
}
else {
vErrors.push(err163);
}
errors++;
}
}
let i35 = data100.length;
let j2;
if(i35 > 1){
outer1:
for(;i35--;){
for(j2 = i35; j2--;){
if(func0(data100[i35], data100[j2])){
const err164 = {instancePath:instancePath+"/renderTargets",schemaPath:"#/properties/renderTargets/uniqueItems",keyword:"uniqueItems",params:{i: i35, j: j2},message:"must NOT have duplicate items (items ## "+j2+" and "+i35+" are identical)"};
if(vErrors === null){
vErrors = [err164];
}
else {
vErrors.push(err164);
}
errors++;
break outer1;
}
}
}
}
}
else {
const err165 = {instancePath:instancePath+"/renderTargets",schemaPath:"#/properties/renderTargets/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err165];
}
else {
vErrors.push(err165);
}
errors++;
}
}
if(data.publicationTargets !== undefined){
let data102 = data.publicationTargets;
if(Array.isArray(data102)){
const len33 = data102.length;
for(let i36=0; i36<len33; i36++){
let data103 = data102[i36];
if(!((data103 === "google-docs") || (data103 === "notion"))){
const err166 = {instancePath:instancePath+"/publicationTargets/" + i36,schemaPath:"#/properties/publicationTargets/items/enum",keyword:"enum",params:{allowedValues: schema76.properties.publicationTargets.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err166];
}
else {
vErrors.push(err166);
}
errors++;
}
}
let i37 = data102.length;
let j3;
if(i37 > 1){
outer2:
for(;i37--;){
for(j3 = i37; j3--;){
if(func0(data102[i37], data102[j3])){
const err167 = {instancePath:instancePath+"/publicationTargets",schemaPath:"#/properties/publicationTargets/uniqueItems",keyword:"uniqueItems",params:{i: i37, j: j3},message:"must NOT have duplicate items (items ## "+j3+" and "+i37+" are identical)"};
if(vErrors === null){
vErrors = [err167];
}
else {
vErrors.push(err167);
}
errors++;
break outer2;
}
}
}
}
}
else {
const err168 = {instancePath:instancePath+"/publicationTargets",schemaPath:"#/properties/publicationTargets/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err168];
}
else {
vErrors.push(err168);
}
errors++;
}
}
if(data.targetOverlays !== undefined){
let data104 = data.targetOverlays;
if(Array.isArray(data104)){
if(data104.length < 1){
const err169 = {instancePath:instancePath+"/targetOverlays",schemaPath:"#/properties/targetOverlays/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err169];
}
else {
vErrors.push(err169);
}
errors++;
}
const len34 = data104.length;
for(let i38=0; i38<len34; i38++){
if(!(validate62(data104[i38], {instancePath:instancePath+"/targetOverlays/" + i38,parentData:data104,parentDataProperty:i38,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate62.errors : vErrors.concat(validate62.errors);
errors = vErrors.length;
}
}
let i39 = data104.length;
let j4;
if(i39 > 1){
outer3:
for(;i39--;){
for(j4 = i39; j4--;){
if(func0(data104[i39], data104[j4])){
const err170 = {instancePath:instancePath+"/targetOverlays",schemaPath:"#/properties/targetOverlays/uniqueItems",keyword:"uniqueItems",params:{i: i39, j: j4},message:"must NOT have duplicate items (items ## "+j4+" and "+i39+" are identical)"};
if(vErrors === null){
vErrors = [err170];
}
else {
vErrors.push(err170);
}
errors++;
break outer3;
}
}
}
}
}
else {
const err171 = {instancePath:instancePath+"/targetOverlays",schemaPath:"#/properties/targetOverlays/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err171];
}
else {
vErrors.push(err171);
}
errors++;
}
}
}
else {
const err172 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err172];
}
else {
vErrors.push(err172);
}
errors++;
}
validate45.errors = vErrors;
return errors === 0;
}
validate45.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate20(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://cogo.xyz/schemas/v4/document-template-family.cogo.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate20.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.schemaVersion === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "schemaVersion"},message:"must have required property '"+"schemaVersion"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.familyId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "familyId"},message:"must have required property '"+"familyId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.familyVersion === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "familyVersion"},message:"must have required property '"+"familyVersion"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.name === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.description === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "description"},message:"must have required property '"+"description"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.metadata === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "metadata"},message:"must have required property '"+"metadata"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.legacyTemplateRefs === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "legacyTemplateRefs"},message:"must have required property '"+"legacyTemplateRefs"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.semanticCore === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "semanticCore"},message:"must have required property '"+"semanticCore"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.promotionPolicy === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "promotionPolicy"},message:"must have required property '"+"promotionPolicy"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.variants === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "variants"},message:"must have required property '"+"variants"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema31.properties, key0))){
const err10 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.schemaVersion !== undefined){
if("cogo.document-template-family.v2" !== data.schemaVersion){
const err11 = {instancePath:instancePath+"/schemaVersion",schemaPath:"#/properties/schemaVersion/const",keyword:"const",params:{allowedValue: "cogo.document-template-family.v2"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.familyId !== undefined){
let data1 = data.familyId;
if(typeof data1 === "string"){
if(!pattern4.test(data1)){
const err12 = {instancePath:instancePath+"/familyId",schemaPath:"#/$defs/KebabId/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9]+(?:-[a-z0-9]+)*$"},message:"must match pattern \""+"^[a-z0-9]+(?:-[a-z0-9]+)*$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/familyId",schemaPath:"#/$defs/KebabId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.familyVersion !== undefined){
let data2 = data.familyVersion;
if(typeof data2 === "string"){
if(!pattern5.test(data2)){
const err14 = {instancePath:instancePath+"/familyVersion",schemaPath:"#/$defs/Semver/pattern",keyword:"pattern",params:{pattern: "^[0-9]+\\.[0-9]+\\.[0-9]+$"},message:"must match pattern \""+"^[0-9]+\\.[0-9]+\\.[0-9]+$"+"\""};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/familyVersion",schemaPath:"#/$defs/Semver/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.name !== undefined){
let data3 = data.name;
if(typeof data3 === "string"){
if(func2(data3) < 1){
const err16 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.description !== undefined){
let data4 = data.description;
if(typeof data4 === "string"){
if(func2(data4) < 1){
const err18 = {instancePath:instancePath+"/description",schemaPath:"#/properties/description/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/description",schemaPath:"#/properties/description/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.metadata !== undefined){
if(!(validate21(data.metadata, {instancePath:instancePath+"/metadata",parentData:data,parentDataProperty:"metadata",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
errors = vErrors.length;
}
}
if(data.legacyTemplateRefs !== undefined){
let data6 = data.legacyTemplateRefs;
if(Array.isArray(data6)){
const len0 = data6.length;
for(let i0=0; i0<len0; i0++){
if(!(validate23(data6[i0], {instancePath:instancePath+"/legacyTemplateRefs/" + i0,parentData:data6,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate23.errors : vErrors.concat(validate23.errors);
errors = vErrors.length;
}
}
}
else {
const err20 = {instancePath:instancePath+"/legacyTemplateRefs",schemaPath:"#/properties/legacyTemplateRefs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.semanticCore !== undefined){
if(!(validate25(data.semanticCore, {instancePath:instancePath+"/semanticCore",parentData:data,parentDataProperty:"semanticCore",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
errors = vErrors.length;
}
}
if(data.promotionPolicy !== undefined){
let data9 = data.promotionPolicy;
if(data9 && typeof data9 == "object" && !Array.isArray(data9)){
if(data9.humanPromotionRequired === undefined){
const err21 = {instancePath:instancePath+"/promotionPolicy",schemaPath:"#/$defs/PromotionPolicy/required",keyword:"required",params:{missingProperty: "humanPromotionRequired"},message:"must have required property '"+"humanPromotionRequired"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data9.automatedPromotionAllowed === undefined){
const err22 = {instancePath:instancePath+"/promotionPolicy",schemaPath:"#/$defs/PromotionPolicy/required",keyword:"required",params:{missingProperty: "automatedPromotionAllowed"},message:"must have required property '"+"automatedPromotionAllowed"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data9.modelMayApprove === undefined){
const err23 = {instancePath:instancePath+"/promotionPolicy",schemaPath:"#/$defs/PromotionPolicy/required",keyword:"required",params:{missingProperty: "modelMayApprove"},message:"must have required property '"+"modelMayApprove"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data9.evidenceRequired === undefined){
const err24 = {instancePath:instancePath+"/promotionPolicy",schemaPath:"#/$defs/PromotionPolicy/required",keyword:"required",params:{missingProperty: "evidenceRequired"},message:"must have required property '"+"evidenceRequired"+"'"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
for(const key1 in data9){
if(!((((key1 === "humanPromotionRequired") || (key1 === "automatedPromotionAllowed")) || (key1 === "modelMayApprove")) || (key1 === "evidenceRequired"))){
const err25 = {instancePath:instancePath+"/promotionPolicy",schemaPath:"#/$defs/PromotionPolicy/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data9.humanPromotionRequired !== undefined){
if(true !== data9.humanPromotionRequired){
const err26 = {instancePath:instancePath+"/promotionPolicy/humanPromotionRequired",schemaPath:"#/$defs/PromotionPolicy/properties/humanPromotionRequired/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data9.automatedPromotionAllowed !== undefined){
if(false !== data9.automatedPromotionAllowed){
const err27 = {instancePath:instancePath+"/promotionPolicy/automatedPromotionAllowed",schemaPath:"#/$defs/PromotionPolicy/properties/automatedPromotionAllowed/const",keyword:"const",params:{allowedValue: false},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data9.modelMayApprove !== undefined){
if(false !== data9.modelMayApprove){
const err28 = {instancePath:instancePath+"/promotionPolicy/modelMayApprove",schemaPath:"#/$defs/PromotionPolicy/properties/modelMayApprove/const",keyword:"const",params:{allowedValue: false},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data9.evidenceRequired !== undefined){
if(true !== data9.evidenceRequired){
const err29 = {instancePath:instancePath+"/promotionPolicy/evidenceRequired",schemaPath:"#/$defs/PromotionPolicy/properties/evidenceRequired/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
else {
const err30 = {instancePath:instancePath+"/promotionPolicy",schemaPath:"#/$defs/PromotionPolicy/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data.variants !== undefined){
let data14 = data.variants;
if(Array.isArray(data14)){
if(data14.length < 1){
const err31 = {instancePath:instancePath+"/variants",schemaPath:"#/properties/variants/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
const len1 = data14.length;
for(let i1=0; i1<len1; i1++){
if(!(validate45(data14[i1], {instancePath:instancePath+"/variants/" + i1,parentData:data14,parentDataProperty:i1,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate45.errors : vErrors.concat(validate45.errors);
errors = vErrors.length;
}
}
}
else {
const err32 = {instancePath:instancePath+"/variants",schemaPath:"#/properties/variants/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
}
else {
const err33 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
validate20.errors = vErrors;
return errors === 0;
}
validate20.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};
